import React, { useEffect, useRef, useState } from 'react'
import { APPLICATION_JSON, DEFAULT_IMAGE_140 } from '../../middleware/types'
import Helper from '../Helper'
import AddShoppingListModal from '../PlpSection/AddShoppingListModal'
import { Link } from 'react-router-dom'
import useStateRef from 'react-usestateref'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Loader from '../Loader/Loader';
import { getProfileDetailsAction } from '../../middleware/getProfileDetailsAction'
import { updateProfileDetailsAction } from '../../middleware/updateProfileDetailsAction'
import ProductRestrictionModal from '../CheckOutSection/ProductRestrictionModal'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { redirectUrlAction } from '../../middleware/redirectUrlAction'
import YouMayAlso from '../PdpSection/YouMayAlso'
import ProductQuickViewModal from '../PlpSection/ProductQuickViewModal'
import { CartDetailsAction } from '../../middleware/CartDetailsAction'
import ProductRestrictModalCart from './ProductRestrictModalCart'
import './ShoppingCart.css'

const ShoppingCartV2 = ({ containerObject, templateName, contentId, dataZone }) => {

    let history = useHistory();
    const [cartList, setCartList, cartListRef] = useStateRef();
    const [subTotal, setSubTotal] = useState()
    const [cartQuantityErrorMsg, setCartQuantityErrorMsg, cartQuantityErrorMsgRef] = useStateRef(false);
    const [PromotionalCodeErrorMsg, setPromotionalCodeErrorMsg, PromotionalCodeErrorMsgRef] = useStateRef()
    const [userType, setUserType, userTypeRef] = useStateRef()
    const [shippingCharge, setShippingCharge, shippingChargeRef] = useStateRef()
    const [isLoading, setIsLoading] = useState(false);
    const [zipValue, setZipValue] = useState("estimate")
    const [discountAvailable, setDiscountAvailable] = useState(true);
    const [promoValue, setPromoValue] = useState("apply code")
    const [transient, setTransient] = useState(false)
    const [commerceItemDetails, setCommerceItemDetails] = useState()
    const [hasError, setHasError, hasErrorRef] = useStateRef(false);
    const [promoRemoved, setPromoRemoved] = useState(true);
    const profileDetail = useSelector(state => state.getProfileDetails.profileDetails)
    const [estimateShipping, setEstimateShipping, estimateShippingRef] = useStateRef()
    const dispatch = useDispatch();
    const [successCart, setSuccessCart] = useState(false)
    const [emptyCart, setEmptyCart] = useState();
    const [headMsg, setHeadMsg, headMsgRef] = useStateRef("");
    const [contractTerms, setContractTerms, contractTermsRef] = useStateRef("");
    const [checkoutHref, setCheckoutHref] = useState('/checkout/login');
    const [checkoutQuarantine, setCheckoutQuarantine, checkoutQuarantineRef] = useStateRef(null);
    const [restrictedItem, setRestrictedItem] = useState();
    const [restrictedItemGeo, setRestrictedItemGeo] = useState();
    const [restrictedItemSpecialUser, setRestrictedItemSpecialUser] = useState();
    const [restrictedDiscontinueItem, setRestrictedDiscontinueItem] = useState();
    const [restrictedTitle, setRestrictedTitle] = useState();
    const [restrictErrorMsg, setRestrictErrorMsg, restrictErrorMsgRef] = useStateRef()
    const [showTooltip, setShowTooltip] = useState(false);
    const [showTooltip1, setShowTooltip1] = useState(false);
    const [showTooltip2, setShowTooltip2] = useState(false);
    const [siteSpecDetails, setSiteSpecDetails, siteSpecDetailsRef] = useStateRef()
    const [discountMessage, setDiscountMessage, discountMessageRef] = useStateRef()
    const [promotionId, setPromotionId, promotionIdRef] = useStateRef()
    const [promotionIdInvalid, setPromotionIdInvalid, promotionIdInvalidRef] = useStateRef(false)
    const [productDetailsObj, setProductDetailsObj, productDetailsObjRef] = useStateRef()
    const [hasScrollView, setHasScrollView] = useState(false);
    const [dataLayer, setDataLayer, dataLayerRef] = useStateRef('');
    const [productQty, setProductQty, productQtyRef] = useStateRef('');
    const [currentQty, setCurrentQty, currentQtyRef] = useStateRef('');
    const [currentCommerceId, setCurrentCommerceId, currentCommerceIdRef] = useStateRef('');
    const [cartProductDetails, setCartProductDetails] = useState('')
    const [isPunchout, setIsPunchout, isPunchoutRef] = useStateRef(false)
    const [discountEnableMsg, setDiscountEnableMsg, discountEnableMsgRef] = useStateRef('');
    const [isPunchoutInspect, setIsPunchoutInspect] = useState(false);
    const [externalRedirectionURL, setExternalRedirectionURL, externalRedirectionURLRef] = useStateRef();
    const [cartProductList, setCartProductList, cartProductListRef] = useStateRef();
    const [sessionId, setSessionId, sessionIdRef] = useStateRef();
    const [cartBelowArea, setCartBelowArea, cartBelowAreaRef] = useStateRef();
    const cartDetails = useSelector(state => state.getCartDetails.cartDetails);
    const [isRestrictedModalShow, setIsRestrictedModalShow, isRestrictedModalShowRef] = useStateRef(false);
    const [hideModal, setHideModal, hideModalRef] = useStateRef(false);
    const [search, setSearch, searchRef] = useStateRef("");
    const errorDivRef = useRef(null);

    const line = 1
    var urlParam = history.location.pathname;

    const handleMouseEnter = () => {
        setShowTooltip(true);
    };
    const handleMouseLeave = () => {
        setShowTooltip(false);
    };
    const handleMouseEnter1 = () => {
        setShowTooltip1(true);
    };
    const handleMouseLeave1 = () => {
        setShowTooltip1(false);
    };
    const handleMouseEnter2 = () => {
        setShowTooltip2(true);
    };
    const handleMouseLeave2 = () => {
        setShowTooltip2(false);
    };
    function replaceImage(event) {

        event.target.src = DEFAULT_IMAGE_140;

    }
    const handlePromoHoverLeave = (id) => {
        document.getElementById(id).classList.remove("d-block");
        document.getElementById(id).classList.add("d-none");
    };
    const handlePromoHoverEnter = (id) => {
        document.getElementById(id).classList.remove("d-none");
        document.getElementById(id).classList.add("d-block");
    };

    function handleFormEmpty(e) {
        if (document.querySelector('#quickViewModal')) {
            document.querySelector('#quickViewModal').addEventListener('hidden.bs.modal', function (e) {
                if (document.getElementById("addToCart")) {
                    document.getElementById("addToCart").reset();
                }
            })
        }
    }
    useEffect(() => {
        handleGetCartList()
        handleFormEmpty()
        console.log("cart=-=-=", window.location.pathname)
        setSearch(window.location.pathname)
        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/cart/cart-bottom-area`, {
            method: 'GET',
            headers: new Headers({
                "content-Type": "application/json",
            })
        }).then(res => res.json())
            .then(res => {
                if (res.result == "success") {
                    console.log("Success result ---->>>>")
                    setCartBelowArea(res.targeterResult)
                } else {
                    console.log("Error result ---->>>>")
                }
            })
    }, [])
    useEffect(() => {
        if (searchRef.current == "/checkout/cart" && urlParam) {
            console.log('urlParam..', urlParam);
            if (urlParam == '/checkout/inspect/cart') {
                setIsPunchoutInspect(true);
                console.log('isPunchOutInspect...', isPunchoutInspect);
                isPunchoutInspect && console.log('isPunchoutInspect && ');
                isPunchoutInspect === true && console.log('isPunchoutInspect === true');
            } else {
                isPunchoutInspect && console.log('isPunchoutInspect && false');
            }
        }
    }, [urlParam])

    useEffect(() => {
        console.log('profileDetailsFromCart...', profileDetail);
        if (searchRef.current == "/checkout/cart" && profileDetail && profileDetail.userSegment) {
            console.log('punchoutSession...', profileDetail.userSegment['Punchout Session']);
            if (profileDetail.userSegment['Punchout Session'] === true || profileDetail.userSegment['Punchout Session'] === 'true') {
                setIsPunchout(true);
                console.log('isPunchoutCart....inside..if...', isPunchoutRef && isPunchoutRef.current && isPunchoutRef.current);

            }
            console.log('isPunchoutCart....', isPunchoutRef && isPunchoutRef.current && isPunchoutRef.current);

        }
    }, [profileDetail])

    useEffect(() => {
        if (searchRef.current == "/checkout/cart") {
            if (userTypeRef.current && userTypeRef.current != 3 && profileDetail &&
                profileDetail.userTypeCheck && Object.keys(profileDetail.userTypeCheck).length > 0 &&
                isPunchoutRef.current) {
                {
                    if (profileDetail.userTypeCheck.showShippingforPunchout == true) {
                        document.getElementById("shipping-estimate") && document.getElementById("shipping-estimate").classList.remove("d-none")
                        //document.getElementById("shipping-estimate").classList.add("d-block")
                    } else if (profileDetail.userTypeCheck.showShippingforPunchout == false) {
                        //document.getElementById("shipping-estimate").classList.remove("d-block")
                        document.getElementById("shipping-estimate") && document.getElementById("shipping-estimate").classList.add("d-none")
                        // document.getElementById("freight").classList.remove("d-block")
                        // document.getElementById("freight").classList.add("d-none")
                    }
                }
            }
            if (userTypeRef.current && userTypeRef.current != 3 && profileDetail && profileDetail.userTypeCheck && Object.keys(profileDetail.userTypeCheck).length > 0 && isPunchoutRef.current) {
                // console.log("punchoutUser", containerObject && containerObject.userLoginId && containerObject.userLoginId)
                document.getElementById("promotional-code-div").classList.remove("d-block")
                document.getElementById("promotional-code-div").classList.add("d-none")
                if (document.getElementById("security")) {
                    document.getElementById("security").classList.remove("d-block")
                    document.getElementById("security").classList.add("d-none")
                }
                document.getElementById("tax").classList.remove("d-block")
                document.getElementById("tax").classList.add("d-none")
                if (!emptyCart && document.getElementById("add-cart-to-list")) {
                    document.getElementById("add-cart-to-list").classList.remove("d-block")
                    document.getElementById("add-cart-to-list").classList.add("d-none")
                }
            }
            if (userTypeRef.current && userTypeRef.current.transient && profileDetail && profileDetail.userTypeCheck && Object.keys(profileDetail.userTypeCheck).length > 0 && isPunchoutRef.current) {
                console.log('account-benefits hidden../');
                document.getElementById("account-benefits").classList.remove("d-block")
                document.getElementById("account-benefits").classList.add("d-none")
            }
            if (userTypeRef.current && userTypeRef.current === 2 && profileDetail && profileDetail.userTypeCheck && Object.keys(profileDetail.userTypeCheck).length > 0 && isPunchoutRef.current) {
                document.getElementById("account-benefits2").classList.remove("d-block")
                document.getElementById("account-benefits2").classList.add("d-none")
            }
        }
    }, [userTypeRef.current, isPunchoutRef.current])


    useEffect(() => {
        if (searchRef.current == "/checkout/cart") {
            var url = history.location.pathname
            console.log("cart-page-url", url)
            var splitedUri = url.split("/")
            var search = splitedUri[1] + "/" + splitedUri[2]
            if (search == "checkout/cart" && profileDetail && profileDetail.mergeOrderFlag == true && successCart) {
                fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/cart/merge-modal-details`, {
                    method: 'GET',
                    headers: new Headers({
                        "content-Type": "application/json",
                    })
                }).then(res => res.json())
                    .then(res => {
                        if (res.result == "success") {
                            setCommerceItemDetails(JSON.parse(res.response).response)
                        } else {
                            console.log("Error result ---->>>>")
                        }
                    })
                triggerModal()
            }
        }
    }, [successCart])

    useEffect(() => {
        if (searchRef.current == "/checkout/cart") {
            if (profileDetail && profileDetail.transient) {
                setUserType(profileDetail)
            }
            if (profileDetail && !profileDetail.transient && profileDetail.userType) {
                setUserType(profileDetail.userType)
            }
        }
    }, [profileDetail])


    useEffect(() => {
        if (searchRef.current == "/checkout/cart") {
            const profileDetailRestricted = () => {
                if (profileDetail) {
                    if (!profileDetail?.hasOwnProperty('transient')) {
                        // console.log("User is logged in.");
                        if (userTypeRef.current && userTypeRef.current === 3) {
                            // console.log("User type is 3");
                            setCheckoutHref('/checkout/int/save')
                        } else {
                            // console.log("User type is not equal to 3");
                            setCheckoutHref('/checkout/shipping')
                        }
                    } else {
                        console.log("User is anonymous.");
                        // dispatch(redirectUrlAction("/checkout/login"))
                        // setCheckoutHref('/checkout/login')
                    }
                }
            }
            profileDetailRestricted()
        }
    }, [profileDetail])

    useEffect(() => {
        if (searchRef.current == "/checkout/cart") {
            let delay
            delay = setTimeout(() => {
                if (currentQtyRef.current) {
                    handleQuantityChange();

                }
            }, 1000)
            return () => clearTimeout(delay)
        }
    }, [productQtyRef.current])

    function handleQuickView(quickViewDetails) {
        setProductDetailsObj(quickViewDetails)

    }
    // const [commerceIdsList, setCommerceIdsList] = useState('')
    function handlePrintPage() {
        window.print()
    }

    const handleClearErrMsg = () => {
        if (document.getElementById("errMsgAlert")) {
            document.getElementById("errMsgAlert").classList.remove("d-block")
            document.getElementById("errMsgAlert").classList.add("d-none")
        }
        if (document.getElementById("eventName")) {
            document.getElementById("eventName").classList.remove("form-error")
        }

    }

    const triggerModal = () => {
        var mergeCartBtn = document.getElementById("mergeModal");
        mergeCartBtn.setAttribute("data-bs-toggle", "modal");
        mergeCartBtn.setAttribute("data-bs-target", "#mergeCartModal");
        mergeCartBtn.click();
    }
    const handleClose = () => {
        document.getElementById("merge-cart-close").click()
    }
    const handleMergeCart = (event) => {
        setIsLoading(true)
        const inputMap = {
            "cartType": event,
            "selectCart": "submit"
        }
        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/cart/mergeCart`, {
            method: 'POST',
            headers: new Headers({
                "content-Type": "application/json",
            }),
            body: JSON.stringify(inputMap)
        }).then(res => res.json())
            .then(res => {
                if (res.result == "success") {
                    setIsLoading(false)
                    document.getElementById("merge-cart-close").click()
                    dispatch(updateProfileDetailsAction(true))
                    if (event != "previousCart") {
                        populateGetCartList(res.cartDetails)
                    }
                    //window.location.reload();
                } else {
                    setIsLoading(false)
                    console.log("Error result ---->>>>")
                }
            })
    }

    async function handleCheckOut() {

        if (profileDetail?.hasOwnProperty('transient')) {
            dispatch(redirectUrlAction("/checkout/login"))
            setCheckoutHref('/checkout/login');

        }
        if (userTypeRef.current && userTypeRef.current !== 3) {
            await goToCheckout();
            var actionUrl = "api/rest/cb/cart/quarantine";
            var urlParam = `urlParam=${checkoutHref}&checkoutType=mainCart`
            var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
            var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify({
                urlParam: urlParam
            }))
            if (res.result == "success") {
                var response = (JSON.parse(res.response)).response
                var restrictTitle = response?.restrictionProductsList ? response.restrictionProductsList : ''
                var restrictDiscontinueItem = response?.restrictionProductsList?.discontinuedProducts?.productDetailsList ?
                    response.restrictionProductsList.discontinuedProducts.productDetailsList : ''
                var specificUsersRestrictionMap = response?.restrictionProductsList?.specificUsersRestriction?.productDetailsList ?
                    response.restrictionProductsList.specificUsersRestriction.productDetailsList : ''
                var restrictSchoolMap = response?.restrictionProductsList?.schoolrestriction?.productDetailsList ?
                    response.restrictionProductsList.schoolrestriction.productDetailsList : ''
                var restrictGeoMap = response?.restrictionProductsList?.geoRestriction?.productDetailsList ?
                    response.restrictionProductsList.geoRestriction.productDetailsList : ''
                setRestrictedTitle(restrictTitle)
                setRestrictedDiscontinueItem(restrictDiscontinueItem)
                setRestrictedItem(restrictSchoolMap)
                setRestrictedItemGeo(restrictGeoMap)
                setRestrictedItemSpecialUser(specificUsersRestrictionMap)
                console.log("success result ---->>>>", response)
                var restricteditem = response && response.quarantine
                var isCartEmptyCart = response && response.isCartEmptyCart
                console.log('modalShow.../', isRestrictedModalShowRef.current);
                if (restricteditem == 'true') {
                    if (!isRestrictedModalShowRef.current) {
                        console.log('modalOpeneddddd.......');
                        setIsRestrictedModalShow(true)
                        var modalElement = document.getElementById(`productRestrictionModal0`);
                        var bootstrapModal = new bootstrap.Modal(modalElement);
                        bootstrapModal.show();
                    }
                } else {
                    if (isCartEmptyCart == true) {
                        document.getElementById('productRestrictionModal0Close') && document.getElementById('productRestrictionModal0Close').click();
                        if (checkoutQuarantineRef.current === '/checkout/shipping?qr=true') {
                            setCheckoutQuarantine(checkoutHref)
                        }
                    } else {
                        setHideModal(true);
                        if (checkoutQuarantineRef.current === '/checkout/login?qr=true') {
                            window.location.href = '/checkout/login?qr=true'
                        } else if (checkoutQuarantineRef.current === '/checkout/shipping?qr=true') {
                            window.location.href = '/checkout/shipping?qr=true'
                        } else {
                            console.log("line---415", checkoutHref)
                            window.location.href = checkoutHref
                        }
                    }
                }
            }
        } else {
            await goToCheckout();
            window.location.href = checkoutHref
        }

    }

    const handlePunchOutCheckOut = (event) => {

        var punchoutData = document.getElementById("punchout_div")
        setExternalRedirectionURL(profileDetail && profileDetail.externalRedirectionURL)
        const inputMap = {
            "exportCart": "true"
        }
        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/cart/punchout-cart-details`, {
            method: 'POST',
            headers: new Headers({
                "content-Type": "application/json",
            }),
            body: JSON.stringify(inputMap)
        }).then(res => res.json())
            .then(res => {
                if (res.result == "success") {
                    console.log("ExternalRedirectionURL", res.redirect)
                    setCartProductList(res.productList)
                    setSessionId(res.sessionId)
                    document.getElementById("punchoutPortalFormSubmit").click()
                } else {
                    console.log("Error result ---->>>>")
                }
            })
    }

    const handleRemoveCode = (event) => {
        document.getElementById("promotional-code-messaging").classList.remove("d-block")
        document.getElementById("promotional-code-messaging").classList.add("d-none")
        if (document.getElementById("loadingSectionAnimationPromo")) {
            document.getElementById("loadingSectionAnimationPromo").classList.remove("d-none")
        }
        if (document.getElementById("loadingSectionAnimationPromo")) {
            document.getElementById("loadingSectionAnimationPromo").classList.add("d-block")
        }
        document.getElementById("freight-loader").classList.remove("d-none")
        document.getElementById("freight-loader").classList.add("d-block")
        document.getElementById("promotional-code").classList.remove("quantity-error")
        if (document.getElementById("promo-discount")) {
            document.getElementById("promo-discount").classList.remove("visible")
            document.getElementById("promo-discount").classList.add("invisible")
        }
        document.getElementById("freight").classList.remove("visible")
        document.getElementById("freight").classList.add("invisible")
        document.getElementById("tax").classList.remove("visible")
        document.getElementById("tax").classList.add("invisible")
        document.getElementById("subtotal").classList.add("invisible")
        const promotionCode = document.getElementById("promotional-code").value
        const inputMap = {
            actionType: "removeCouponCode",
            couponId: promotionCode
        }
        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/cart/remove-promo-code`, {
            method: 'POST',
            headers: new Headers({
                "content-Type": "application/json",
            }),
            body: JSON.stringify(inputMap)
        }).then(res => res.json())
            .then(res => {
                if (res.result == "success") {
                    document.getElementById("promo-form").reset()
                    setPromotionalCodeErrorMsg("")
                    document.getElementById("promotional-code").classList.remove("quantity-error")
                    document.getElementById("promotional-code").setAttribute("defaultValue", "")
                    document.getElementById("promo-error").classList.remove("d-block")
                    document.getElementById("promo-error").classList.add("d-none")
                    setPromoRemoved(false)
                    document.getElementById('promo-form').reset()
                    setPromotionId()
                    setDiscountMessage()
                    // handleGetCartList();
                    populateGetCartList(res.cartDetails)

                } else {
                    //  setIsLoading(false)
                    console.log("Error result ---->>>>")
                    //location.reload()
                }
            })
    }

    const changeToUpperCase = (event) => {
        event.target.value = event.target.value.toUpperCase();
    }

    function RestrictFirstZero(event) {
        var value = document.getElementById("qo-qty").value
        var result = Helper.isEmpty(value)
        var validation = "^[1-9][0-9]*$";
        var regex = RegExp(validation);

        if (!regex.test(value)) {
            setHasError(true);
            event.target.value = value.replace(value, '');
            document.getElementById("quickOrderError").classList.remove("d-none");
            document.getElementById("quickOrderError").classList.add("d-block");
            document.getElementById("quickOrderError").innerHTML = "Enter valid item or qty";
            document.getElementById("qo-qty").classList.add("quantity-error")
        } else if (result) {
            setHasError(true);
            // setCartQuantityErrorMsg("Enter valid item or qty")
            document.getElementById("quickOrderError").classList.remove("d-none");
            document.getElementById("quickOrderError").classList.add("d-block");
            document.getElementById("quickOrderError").innerHTML = "Enter valid item or qty";
            document.getElementById("qo-qty").classList.add("quantity-error")
        } else {
            setHasError(false);
            document.getElementById("quickOrderError").classList.remove("d-block");
            document.getElementById("quickOrderError").classList.add("d-none");
            document.getElementById("quickOrderError").innerHTML = "";
            document.getElementById("qo-qty").classList.remove("quantity-error")
        }
    };

    const handleGetCartListSuccess = (cartDetails) => {
        console.log('cartDetails...,', cartDetails);
        setIsLoading(false)
        setSuccessCart(true)
        console.log("success--- cartDetails", cartDetails.response && JSON.parse(cartDetails.response))
        setCartList(cartDetails.commerceItems && JSON.parse(cartDetails.commerceItems))
        cartListRef.current && dispatch(CartDetailsAction(cartListRef.current))
        console.log("emptyCart", cartDetails.isEmptyCart)
        setEmptyCart(cartDetails.isEmptyCart)
        // cartDetails && cartDetails.dataLayer && cartDetails.dataLayer.length > 0 && JSON.parse(cartDetails.dataLayer) ? JSON.parse(cartDetails.dataLayer).map((value, key) => {
        //     if (value.dataLayerJson) {
        //         setDataLayer(value.dataLayerJson);
        //         console.log('dataLayer...', dataLayerRef.current);
        //     }

        {
            cartListRef.current && cartListRef.current.map((value, key) => {

                if (value.commerceId) {
                    setProductQty((prevState) => {
                        return {
                            ...prevState,
                            [value.commerceId]: value.quantity
                        };
                    });
                }
            })
        }
        console.log('productQty...', productQtyRef.current);
        if (dataLayerRef.current) {
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push(dataLayerRef.current)
            console.log(window.dataLayer)
        }
        const discountEnableObj = cartListRef.current && cartListRef.current.length > 0 ? cartListRef.current.find(obj => obj.discountEnableAlertMessage !== undefined) : '';
        console.log('discountEnableMsgRef...1', discountEnableObj && discountEnableObj.discountEnableAlertMessage ? discountEnableObj.discountEnableAlertMessage : '');
        if (discountEnableObj && discountEnableObj.discountEnableAlertMessage) {
            setDiscountEnableMsg(discountEnableObj.discountEnableAlertMessage);
        } else {
            setDiscountEnableMsg('');
        }


        setHeadMsg(cartDetails && cartDetails.headMsg && JSON.parse(cartDetails.headMsg))
        setSubTotal(cartDetails.subTotal && cartDetails.subTotal)
        setEstimateShipping(cartDetails.shippingCharge && JSON.parse(cartDetails.shippingCharge))
        console.log("setEstimateShipping", estimateShippingRef.current)
        if (estimateShippingRef.current && estimateShippingRef.current.discountAmount && document.getElementById("promo-discount")) {
            document.getElementById("promo-discount").classList.remove("invisible")
            document.getElementById("promo-discount").classList.add("visible")
        }
        if (document.getElementById("addToCartLoading")) {
            document.getElementById("addToCartLoading").classList.remove("d-block")
            document.getElementById("addToCartLoading").classList.add("d-none")
        }
        if (document.getElementById("qo-item-id"))
            document.getElementById("qo-item-id").value = "";
        // if (cartList && cartList.response) {
        //     document.getElementById("cart-item-row").scrollIntoView({ behavior: 'smooth' });
        // }

        var itemSet = [];
        var rule = [];
        if (cartDetails.isEmptyCart) {
            const map = {
                algorithm: "complementary",
                itemSet: itemSet,
                num: 10,
                rules: rule,
                "user": "G7382463176476012179"
            }
            const inputMap = {
                spectMap: map
            }
            siteSpec(inputMap)
        } else {
            var productId = cartDetails.productId;
            console.log("productId", productId)
            productId && productId.map((oneProductId) => {
                itemSet.push(oneProductId)
            })
            const map = {
                algorithm: "complementary",
                itemSet: itemSet,
                num: 10,
                rules: rule
            }
            const inputMap = {
                spectMap: map
            }
            siteSpec(inputMap)
        }

        // console.log("map", map);

        async function siteSpec(inputMap) {
            var Url = `${window.location.protocol}//${window.location.hostname}/api/rest/cb/cart/sitespect-details`

            var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify(inputMap))

            setSiteSpecDetails(res.response)
            // console.log("resfromSpec", res);
        }
        console.log("userTypeRef.current", userTypeRef.current)
        if (userTypeRef.current && userTypeRef.current != 3) {
            if (estimateShippingRef.current != null) {
                // setIsLoading(false)
                console.log("userTypeRef.current1", userTypeRef.current)
                if (document.getElementById("loadingSectionAnimation")) {
                    document.getElementById("loadingSectionAnimation").classList.remove("d-block")
                    document.getElementById("loadingSectionAnimation").classList.add("d-none")
                }
                if (document.getElementById("freight-loader")) {
                    document.getElementById("freight-loader").classList.remove("d-block")
                    document.getElementById("freight-loader").classList.add("d-none")
                }
                if (document.getElementById("freight")) {
                    document.getElementById("freight").classList.remove("invisible")
                    document.getElementById("freight").classList.add("visible")
                }
                if (document.getElementById("tax")) {
                    document.getElementById("tax").classList.remove("invisible")
                    document.getElementById("tax").classList.add("visible")
                }

                if (estimateShippingRef.current && estimateShippingRef.current.discountMessage) {
                    if (document.getElementById("promotional-code")) {
                        document.getElementById("promotional-code").setAttribute("defaultValue", estimateShippingRef.current && estimateShippingRef.current.discountMessage)
                        const estimatePromo = document.getElementById("promotional-code")
                    }
                    setPromoValue("change code")
                    if (document.getElementById("promotional-code-messaging")) {
                        document.getElementById("promotional-code-messaging").classList.remove("d-none")
                        document.getElementById("promotional-code-messaging").classList.add("d-block")
                    }
                    if (document.getElementById("promo-remove")) {
                        document.getElementById("promo-remove").classList.remove("d-none")
                        document.getElementById("promo-remove").classList.add("d-block")
                    }
                }
                console.log("estimateShippingRef.current.zipCode", estimateShippingRef.current.zipCode)
                if (estimateShippingRef.current.zipCode != null && document.getElementById("shipping-estimate-zip")) {
                    document.getElementById("shipping-estimate-zip").setAttribute("defaultValue", estimateShippingRef.current && estimateShippingRef.current.zipCode)
                    const estimateZip = document.getElementById("shipping-estimate-zip")
                    console.log("estimateZip", estimateZip)
                    setZipValue(estimateZip && estimateZip.value && estimateZip.value != null ? "update" : "estimate")
                    if (estimateZip && estimateZip.value && estimateZip.value != null) {
                        document.getElementById("shipping-estimate-messaging").classList.remove("d-none")
                        document.getElementById("shipping-estimate-messaging").classList.add("d-block")
                    }
                } else {
                    console.log("line---", "256")
                }
                // const promotionCode = document.getElementById("promotional-code").value
                // console.log("promotionCode---", promotionCode)
                // console.log("estimateShippingRef.current.promotionId", estimateShippingRef.current.promotionId)
            } else {
                if (document.getElementById("shipping-estimate-messaging")) {
                    document.getElementById("shipping-estimate-messaging").classList.remove("d-block")
                    document.getElementById("shipping-estimate-messaging").classList.add("d-none")
                }
            }
        }
    }
    async function populateGetCartList(cartResult) {
        console.log("cartResult", cartResult)
        if (cartResult.result === "success") {
            if (userTypeRef.current && userTypeRef.current != 3) {
                if (document.getElementById("loadingSectionAnimationPromo")) {
                    document.getElementById("loadingSectionAnimationPromo").classList.remove("d-block")
                }
                if (document.getElementById("loadingSectionAnimationPromo")) {
                    document.getElementById("loadingSectionAnimationPromo").classList.add("d-none")
                }
                if (document.getElementById("freight-loader")) {
                    document.getElementById("freight-loader").classList.remove("d-block")
                }
                if (document.getElementById("freight-loader")) {
                    document.getElementById("freight-loader").classList.add("d-none")
                }
                if (document.getElementById("promotional-code")) {
                    document.getElementById("promotional-code").classList.remove("quantity-error")
                }

                if (document.getElementById("promotional-code") && document.getElementById("promotional-code").value
                    && document.getElementById("promo-discount")) {
                    document.getElementById("promo-discount").classList.remove("invisible")
                    document.getElementById("promo-discount").classList.add("visible")
                }
                if (document.getElementById("freight")) {
                    document.getElementById("freight").classList.remove("invisible")
                    document.getElementById("freight").classList.add("visible")
                }
                if (document.getElementById("tax")) {
                    document.getElementById("tax").classList.remove("invisible")
                    document.getElementById("tax").classList.add("visible")
                }
                if (document.getElementById("subtotal")) {
                    document.getElementById("subtotal").classList.remove("invisible")
                    document.getElementById("subtotal").classList.add("visible")
                }
            }
            handleGetCartListSuccess(cartResult);
        }
        else {
            setIsLoading(false)
        }
    }
    async function handleGetCartList() {
        setIsLoading(true)
        const cartParam = window.location.search
        console.log('cartParem------1', cartParam)
        var actionUrl = `api/rest/cb/cart/cart-details/${cartParam === '?create=true' ? 'true' : 'false'}`;
        fetch(`${window.location.protocol}//${window.location.hostname}/${actionUrl}`, {
            method: 'GET'
        }).then(res => res.json())
            .then(res => {
                if (res.result === "success") {
                    "/account/login?resume=list"
                    if (userTypeRef.current && userTypeRef.current != 3) {
                        if (document.getElementById("loadingSectionAnimationPromo")) {
                            document.getElementById("loadingSectionAnimationPromo").classList.remove("d-block")
                        }
                        if (document.getElementById("loadingSectionAnimationPromo")) {
                            document.getElementById("loadingSectionAnimationPromo").classList.add("d-none")
                        }
                        if (document.getElementById("freight-loader")) {
                            document.getElementById("freight-loader").classList.remove("d-block")
                        }
                        if (document.getElementById("freight-loader")) {
                            document.getElementById("freight-loader").classList.add("d-none")
                        }
                        if (document.getElementById("promotional-code")) {
                            document.getElementById("promotional-code").classList.remove("quantity-error")
                        }

                        if (document.getElementById("promotional-code") && document.getElementById("promotional-code").value
                            && document.getElementById("promo-discount")) {
                            document.getElementById("promo-discount").classList.remove("invisible")
                            document.getElementById("promo-discount").classList.add("visible")
                        }
                        if (document.getElementById("freight")) {
                            document.getElementById("freight").classList.remove("invisible")
                            document.getElementById("freight").classList.add("visible")
                        }
                        if (document.getElementById("tax")) {
                            document.getElementById("tax").classList.remove("invisible")
                            document.getElementById("tax").classList.add("visible")
                        }
                        if (document.getElementById("subtotal")) {
                            document.getElementById("subtotal").classList.remove("invisible")
                            document.getElementById("subtotal").classList.add("visible")
                        }
                    }
                    handleGetCartListSuccess(res);
                }
                else {
                    setIsLoading(false)
                }
            })
    }
    async function goToCheckout() {
        var Url = `${window.location.protocol}//${window.location.hostname}/api/rest/cb/cart/go-to-checkout`
        const inputMap = {
            "redirectCheckout": checkoutHref
        }
        var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify(inputMap))
        if (res?.result === 'error') {
            setRestrictErrorMsg(res?.errorMessage)
        }
    }

    const handleRemoveItem = (event) => {
        event.preventDefault();
        setIsLoading(true)
        disableQtyUpdate();
        const inputMap = {
            actionType: "clearCart"
        }
        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/cart/remove-product-from-cart`, {
            method: 'POST',
            headers: new Headers({
                "content-Type": "application/json",
            }),
            body: JSON.stringify(inputMap)
        }).then(res => res.json())
            .then(res => {
                if (res.result == "success") {
                    console.log("line593")
                    // setIsLoading(false)
                    //var shoppingListDetatils = (JSON.parse(res.response)).response.matchedList
                    // location.reload()
                    setProductQty('');
                    dispatch(CartDetailsAction(''));
                    // handleGetCartList();
                    populateGetCartList(res.cartDetails)
                    dispatch(updateProfileDetailsAction(true))
                } else {
                    setIsLoading(false)
                    //  setIsLoading(false)
                    console.log("Error result ---->>>>")
                    //location.reload()
                }

            })
    }
    const enableQtyUpdate = () => {
        cartListRef.current && cartListRef.current.map((value, key) => {
            if (value.commerceId && document.getElementById('qty-' + value.commerceId)) {
                document.getElementById('qty-' + value.commerceId).removeAttribute('disabled');
            }
        })
    }
    const disableQtyUpdate = () => {
        cartListRef.current && cartListRef.current.map((value, key) => {
            if (value.commerceId && document.getElementById('qty-' + value.commerceId)) {
                document.getElementById('qty-' + value.commerceId).setAttribute('disabled', 'disabled');
            }
        })
    }
    const handleOnChangeQty = (event, commerceId) => {
        console.log('handleOnChangeQty called...');
        setCurrentCommerceId(commerceId);
        setCurrentQty(event.currentTarget.value)
        var inputQty = event.currentTarget.value;
        if (isNaN(inputQty)) {
            console.log('its not a number..')
            if (document.getElementById('qty-' + currentCommerceIdRef.current)) {
                document.getElementById('qty-' + currentCommerceIdRef.current).value = "";
            }
            setCurrentQty('');
            setCurrentCommerceId('');
        }
        else if (Number(event.currentTarget.value) >= 0) {
            console.log('its a number....');
            setProductQty((prevState) => {
                return {
                    ...prevState,
                    [commerceId]: event.currentTarget.value
                }
            })
            console.log('currentCommerceId..', currentCommerceIdRef.current);
        }
    }


    const handleQuantityChange = (event, commerceId) => {
        var quantity = currentQtyRef.current;
        console.log('quantity...!', quantity);

        if (quantity == 0) {
            document.getElementById('remove-product-' + currentCommerceIdRef.current).classList.remove('d-none');
            document.getElementById('remove-product-' + currentCommerceIdRef.current).classList.add('d-block');
            setCurrentQty('');
            setCurrentCommerceId('');
        }
        else if (quantity >= 1) {

            // document.getElementById('qty-'+currentCommerceIdRef.current).value = quantity;
            var commerceIdList = [];
            var commerceIdListJoin = "";
            {
                cartListRef.current && cartListRef.current.map((value, key) => {
                    if (value.commerceId && value.quantity) {
                        commerceIdList.push(value.commerceId + "=" + value.quantity)
                    }
                })
            }
            disableQtyUpdate();
            if (commerceIdList.length > 0) {
                commerceIdListJoin = commerceIdList.join(",")
                //setCommerceIdsList(commerceIdListJoin)
            }
            document.getElementById('remove-product-' + currentCommerceIdRef.current).classList.remove('d-block');
            document.getElementById('remove-product-' + currentCommerceIdRef.current).classList.add('d-none');
            document.getElementById('qty-' + currentCommerceIdRef.current) && document.getElementById('qty-' + currentCommerceIdRef.current).classList.remove("quantity-error")
            if (profileDetail && profileDetail.hidePrice && profileDetail.hidePrice === "false") {
                document.getElementById("cart-item-total" + currentCommerceIdRef.current).classList.remove("d-block")
                document.getElementById("cart-item-total" + currentCommerceIdRef.current).classList.add("d-none")
                document.getElementById("qty-total-loader" + currentCommerceIdRef.current).classList.remove("d-none")
                document.getElementById("qty-total-loader" + currentCommerceIdRef.current).classList.add("d-block")
            }
            if (userTypeRef.current && userTypeRef.current != 3) {
                document.getElementById("freight-loader").classList.remove("d-none")
                document.getElementById("freight-loader").classList.add("d-block")
                document.getElementById("shipping-estimate-messaging").classList.remove("d-block")
                document.getElementById("shipping-estimate-messaging").classList.add("d-none")
                document.getElementById("freight").classList.remove("visible")
                document.getElementById("freight").classList.add("invisible")
                document.getElementById("tax").classList.remove("visible")
                document.getElementById("tax").classList.add("invisible")
                if (profileDetail && profileDetail.hidePrice && profileDetail.hidePrice === "false") {
                    document.getElementById("subtotal").classList.remove("invisible")
                    document.getElementById("subtotal").classList.add("visible")
                }
            }
            const inputMap = {
                "itemIds": commerceIdList,
                "actionType": "updateItems",
                "updateId": currentCommerceIdRef.current + "=" + quantity
            }
            fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/cart/update-item`, {
                method: 'POST',
                headers: new Headers({
                    "content-Type": "application/json",
                }),
                body: JSON.stringify(inputMap)
            }).then(res => res.json())
                .then(res => {
                    if (res.result == "success") {
                        // setIsLoading(false)
                        console.log('loader div..', document.getElementById("qty-total-loader" + currentCommerceIdRef.current));
                        dispatch(updateProfileDetailsAction(true));
                        if (profileDetail && profileDetail.hidePrice && profileDetail.hidePrice === "false") {
                            document.getElementById("qty-total-loader" + currentCommerceIdRef.current).classList.remove("d-block")
                            document.getElementById("qty-total-loader" + currentCommerceIdRef.current).classList.add("d-none")
                            document.getElementById("cart-item-total" + currentCommerceIdRef.current).classList.remove("d-none")
                            document.getElementById("cart-item-total" + currentCommerceIdRef.current).classList.add("d-block")
                        }
                        // handleGetCartList()
                        populateGetCartList(res.cartDetails)
                        dispatch(updateProfileDetailsAction(true))
                        enableQtyUpdate();
                        setCurrentQty('');
                        setCurrentCommerceId('');
                    } else {
                        if (profileDetail && profileDetail.hidePrice && profileDetail.hidePrice === "false") {
                            document.getElementById("qty-total-loader" + currentCommerceIdRef.current).classList.remove("d-block")
                            document.getElementById("qty-total-loader" + currentCommerceIdRef.current).classList.add("d-none")
                            document.getElementById("cart-item-total" + currentCommerceIdRef.current).classList.remove("d-none")
                            document.getElementById("cart-item-total" + currentCommerceIdRef.current).classList.add("d-block")
                        }
                        enableQtyUpdate();
                        setCurrentQty('');
                        setCurrentCommerceId('');
                        //  setIsLoading(false)
                        //location.reload()
                    }
                })


        } else {
            document.getElementById('qty-' + currentCommerceIdRef.current).classList.add("quantity-error")
            document.getElementById('qty-' + currentCommerceIdRef.current).value = "";
            setCurrentQty('');
            setCurrentCommerceId('');
        }

    }

    const handleIncrementDecrement = (commerceId, currentQty, actionType) => {
        console.log('commerceId..', commerceId);
        console.log('currentQty..', currentQty);
        console.log('actionType..', actionType);
        console.log("currentQty < 999", currentQty < 999)
        var changedQty = '';
        if (actionType == 'decrement') {
            if (currentQty != 1) {
                changedQty = currentQty - 1;
            }
        } else {
            if (currentQty < 999) {
                changedQty = currentQty + 1;
            }
        }
        if (changedQty != '') {
            setCurrentCommerceId(commerceId);
            setCurrentQty(changedQty)
            setProductQty((prevState) => {
                return {
                    ...prevState,
                    [commerceId]: changedQty
                }
            })
        }
        console.log('currentCommerceId..', currentCommerceIdRef.current);
    }

    const handleRemoveOneItem = (event) => {
        // setIsLoading(true)
        disableQtyUpdate();
        const inputMap = {
            action: "removeOneItem",
            removeOneItem: event
        }
        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/cart/remove-product-from-cart`, {
            method: 'POST',
            headers: new Headers({
                "content-Type": "application/json",
            }),
            body: JSON.stringify(inputMap)
        }).then(res => res.json())
            .then(res => {
                if (res.result == "success") {
                    setIsLoading(false)
                    //var shoppingListDetatils = (JSON.parse(res.response)).response.matchedList
                    // location.reload()
                    if (document.getElementById('remove-product-' + event)) {
                        document.getElementById('remove-product-' + event).classList.remove("d-block");
                        document.getElementById('remove-product-' + event).classList.add("d-none");
                    }
                    // handleGetCartList();
                    populateGetCartList(res.cartDetails)
                    dispatch(updateProfileDetailsAction(true))
                } else {
                    //  setIsLoading(false)
                    setIsLoading(false)
                    console.log("Error result ---->>>>")
                    //location.reload()
                }
                enableQtyUpdate();
            })
    }

    const handlePromoChange = () => {

        document.getElementById("promo-error").classList.remove("d-block")
        document.getElementById("promo-error").classList.add("d-none")
        setPromotionalCodeErrorMsg("")
        document.getElementById("promotional-code").classList.remove("quantity-error")
    }

    async function handlePromotionalCode(event) {
        event.preventDefault()
        setPromotionalCodeErrorMsg("")
        document.getElementById("loadingSectionAnimationPromo").classList.remove("d-none")
        document.getElementById("loadingSectionAnimationPromo").classList.add("d-block")
        document.getElementById("freight-loader").classList.remove("d-none")
        document.getElementById("freight-loader").classList.add("d-block")
        document.getElementById("promotional-code").classList.remove("quantity-error")
        if (document.getElementById("promo-discount") != null) {
            document.getElementById("promo-discount").classList.remove("visible")
            document.getElementById("promo-discount").classList.add("invisible")
        }

        document.getElementById("freight").classList.remove("visible")
        document.getElementById("freight").classList.add("invisible")
        document.getElementById("tax").classList.remove("visible")
        document.getElementById("tax").classList.add("invisible")
        document.getElementById("subtotal").classList.add("invisible")
        const promotionCode = document.getElementById("promotional-code").value
        console.log("promo-code-781", promotionCode)
        if (promotionCode == "" || promotionCode == null) {
            if (promotionIdRef.current || estimateShippingRef.current && estimateShippingRef.current.promotionId) {
                document.getElementById("promo-remove").classList.remove("d-block")
                document.getElementById("promo-remove").classList.add("d-none")
                document.getElementById("promotional-code-messaging").classList.remove("d-block")
                document.getElementById("promotional-code-messaging").classList.add("d-none")
            }
            document.getElementById("loadingSectionAnimationPromo").classList.remove("d-block")
            document.getElementById("loadingSectionAnimationPromo").classList.add("d-none")
            document.getElementById("freight-loader").classList.remove("d-block")
            document.getElementById("freight-loader").classList.add("d-none")
            document.getElementById("promotional-code").classList.add("quantity-error")
            document.getElementById("subtotal").classList.remove("invisible")
            document.getElementById("subtotal").classList.add("visible")
            document.getElementById("emptyMsgPromo").classList.remove("d-none")
            document.getElementById("emptyMsgPromo").classList.add("d-block")
            if (document.getElementById("promo-discount") != null) {
                document.getElementById("promo-discount").classList.remove("invisible")
                document.getElementById("promo-discount").classList.add("visible")
            }
            document.getElementById("freight").classList.remove("invisible")
            document.getElementById("freight").classList.add("visible")
            document.getElementById("tax").classList.remove("invisible")
            document.getElementById("tax").classList.add("visible")

            setPromoValue("apply code")

        } else if (promotionCode != "") {
            setPromotionId(promotionCode)
            document.getElementById("emptyMsgPromo").classList.remove("d-block")
            document.getElementById("emptyMsgPromo").classList.add("d-none")
            var actionUrl = "api/rest/cb/cart/apply-promo-code";
            var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
            var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify({
                actionType: "applyCouponCode",
                couponId: promotionCode
            }))
            if (res.result === "success") {
                // setCartList(JSON.parse(res.response))
                setPromotionIdInvalid(false)
                document.getElementById("loadingSectionAnimationPromo").classList.remove("d-block")
                document.getElementById("loadingSectionAnimationPromo").classList.add("d-none")
                document.getElementById("freight-loader").classList.remove("d-block")
                document.getElementById("freight-loader").classList.add("d-none")
                document.getElementById("promotional-code").classList.remove("quantity-error")
                document.getElementById("subtotal").classList.remove("invisible")
                document.getElementById("subtotal").classList.add("visible")
                const estimatePromo = document.getElementById("promotional-code")
                setPromoValue(estimatePromo && estimatePromo.value ? "change code" : "apply code")
                if ((JSON.parse(res.response)) && (JSON.parse(res.response)).errorMessage &&
                    (JSON.parse(res.response)).errorMessage[0] &&
                    (JSON.parse(res.response)).errorMessage[0].message) {
                    setPromotionalCodeErrorMsg((JSON.parse(res.response)).errorMessage[0].message)
                    document.getElementById("promo-error").classList.remove("d-none")
                    document.getElementById("promo-error").classList.add("d-block")
                    document.getElementById("promotional-code").classList.add("quantity-error")
                }
                setDiscountMessage(JSON.parse(res.response).discountMessage)
                setPromotionId(JSON.parse(res.response).promotionId)
                // handleGetCartList()
                populateGetCartList(res.cartDetails)
            }
            else {
                setDiscountAvailable(false)
                const estimatePromo = document.getElementById("promotional-code")
                if (estimatePromo && estimatePromo.value && estimatePromo.value != null) {
                    document.getElementById("promo-remove").classList.remove("d-none")
                    document.getElementById("promo-remove").classList.add("d-block")
                }
                setPromotionIdInvalid(true)
                setPromotionalCodeErrorMsg((JSON.parse(res.response)).errorMessage[0].message)
                document.getElementById("promo-error").classList.remove("d-none")
                document.getElementById("promo-error").classList.add("d-block")
                document.getElementById("promotional-code-messaging").classList.remove("d-block")
                document.getElementById("promotional-code-messaging").classList.add("d-none")
                document.getElementById("promotional-code").classList.add("quantity-error")
                document.getElementById("loadingSectionAnimationPromo").classList.remove("d-block")
                document.getElementById("loadingSectionAnimationPromo").classList.add("d-none")
                document.getElementById("freight-loader").classList.remove("d-block")
                document.getElementById("freight-loader").classList.add("d-none")
                if (document.getElementById("promo-discount") != null) {
                    document.getElementById("promo-discount").classList.remove("invisible")
                    document.getElementById("promo-discount").classList.add("visible")
                }
                document.getElementById("freight").classList.remove("invisible")
                document.getElementById("freight").classList.add("visible")
                document.getElementById("tax").classList.remove("invisible")
                document.getElementById("tax").classList.add("visible")
                document.getElementById("subtotal").classList.remove("invisible")
                document.getElementById("subtotal").classList.add("visible")
            }
        }
    }

    var productIdList = [];
    var commerceIdList = [];
    var productListJoin = null;
    var commerceIdListJoin = null;
    {
        cartListRef.current ? cartListRef.current.map((value, key) => {
            console.log('value-0=9=9=', value)
            productIdList.push(value.productId ? value.productId : "")
            commerceIdList.push(value.commerceId ? value.commerceId : "")
        }) : ""
    }

    if (productIdList.length > 0) {
        console.log('productIdList.join(",")', productIdList.join(","))
        productListJoin = productIdList.join(",")
        console.log('productIdList.join(",") =-=-', productIdList.join(","))
        // setProductIdsList(productListJoin)
    }
    if (commerceIdList.length > 0) {
        commerceIdListJoin = commerceIdList.join(",")
        //setCommerceIdsList(commerceIdListJoin)
    }

    function handleClickScroll(event) {
        event.preventDefault()
        const element = document.getElementById('quick-order');
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    }

    async function handleQuickOrder(event) {
        event.preventDefault()
        setIsLoading(false)
        var quickOrderQty = document.getElementById("qo-qty").value
        var quickOrderItem = document.getElementById("qo-item-id").value
        var result = Helper.isEmpty(quickOrderQty)
        console.log("qo-qty,qo-item-id", quickOrderQty)
        console.log("qo-qty,qo-item-id result", result)
        if (quickOrderItem.trim() == null || quickOrderItem.trim() == "" || quickOrderItem.trim().length < 6) {
            setHasError(true);
            document.getElementById("quickOrderError").classList.remove("d-none")
            document.getElementById("quickOrderError").classList.add("d-block")
            document.getElementById("qo-item-id").classList.add("quantity-error")
            document.getElementById("quickOrderError").innerHTML = "Enter valid item or qty";
        } else if (result == true) {
            setHasError(true);
            document.getElementById("quickOrderError").classList.remove("d-none")
            document.getElementById("quickOrderError").classList.add("d-block")
            document.getElementById("qo-qty").classList.add("quantity-error")
            document.getElementById("quickOrderError").innerHTML = "Enter valid item or qty";
        } else {
            setHasError(false);
            disableQtyUpdate();
            document.getElementById('addToCart').setAttribute('disabled', 'disabled');
            document.getElementById('qo-qty').setAttribute('disabled', 'disabled');
            document.getElementById('qo-item-id').setAttribute('disabled', 'disabled');
            document.getElementById("quickOrderError").classList.remove("d-block")
            document.getElementById("quickOrderError").classList.add("d-none")
            document.getElementById("quick-order-error").classList.remove("d-block")
            document.getElementById("quick-order-error").classList.add("d-none")
            document.getElementById("qo-item-id").classList.remove("quantity-error")
            if (userTypeRef.current && userTypeRef.current != 3) {
                document.getElementById("freight-loader").classList.remove("d-none")
                document.getElementById("freight-loader").classList.add("d-block")
                document.getElementById("shipping-estimate-messaging").classList.remove("d-block")
                document.getElementById("shipping-estimate-messaging").classList.add("d-none")
                document.getElementById("freight").classList.remove("visible")
                document.getElementById("freight").classList.add("invisible")
                document.getElementById("tax").classList.remove("visible")
                document.getElementById("tax").classList.add("invisible")
            }
            // document.getElementById("subtotal").classList.remove("visible")
            // document.getElementById("subtotal").classList.add("invisible")

            document.getElementById("addToCartLoading").classList.remove("d-none")
            document.getElementById("addToCartLoading").classList.add("d-block")
            var searchParam = window.location.search
            var splitedUri = searchParam.split("=")

            const inputMap = {
                addItemCount: quickOrderQty,
                skuId: quickOrderItem.trim(),
                actionType: "addItemToCart",
                quantity: quickOrderQty
            }
            // setIsLoading(true)

            if (!hasErrorRef.current) {
                var actionUrl = "api/rest/cb/cart/quick-add-to-cart";
                var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
                var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify(inputMap))

                if (res.result === "success") {
                    // setIsLoading(false)
                    // handleGetCartList()
                    populateGetCartList(res.cartDetails)
                    dispatch(updateProfileDetailsAction(true))
                    document.getElementById("addToCartLoading")?.classList.remove("d-block")
                    document.getElementById("addToCartLoading")?.classList.add("d-none")
                    restrictedItem?.forEach((item) => {
                        const viewItem = item?.catalogRefId;
                        const element = document.getElementById(`cart-item-row_${viewItem}`);
                        if (element) {
                            element.classList.remove('restricted-item-row');
                        }
                    });
                    if (userTypeRef.current && userTypeRef.current != 3) {
                        const estimateZip = document.getElementById("shipping-estimate-zip")
                        document.getElementById("shipping-estimate-zip").classList.remove("quantity-error")
                        setZipValue(estimateZip && estimateZip.value && estimateZip.value != null ? "update" : "estimate")

                        document.getElementById("emptyCartMsg").classList.remove("d-block")
                        document.getElementById("emptyCartMsg").classList.add("d-none")
                        const estimatePromo = document.getElementById("promotional-code")
                        setPromoValue(estimatePromo && estimatePromo.value && estimatePromo.value != null ? "change code" : "apply code")

                    }
                    document.getElementById('qo-qty').removeAttribute('disabled');
                    document.getElementById("qo-qty").value = 1;
                    if (errorDivRef.current) {
                        errorDivRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
                      } 
                } else {
                    // setIsLoading(false)
                    //  setIsLoading(false)
                    document.getElementById("addToCartLoading").classList.remove("d-block")
                    document.getElementById("addToCartLoading").classList.add("d-none")

                    document.getElementById("quick-order-error").classList.remove("d-none")
                    document.getElementById("quick-order-error").classList.add("d-block")
                    if (userTypeRef.current && userTypeRef.current != 3) {
                        document.getElementById("freight-loader").classList.remove("d-block")
                        document.getElementById("freight-loader").classList.add("d-none")
                    }
                    if (res.response && JSON.parse(res.response) && JSON.parse(res.response).message) {
                        setCartQuantityErrorMsg(JSON.parse(res.response).message)
                    }
                }
                // setCartQuantityErrorMsg(JSON.parse(res.response).errors)
            }
            document.getElementById('addToCart').removeAttribute('disabled');
            document.getElementById('qo-item-id').removeAttribute('disabled');
            document.getElementById('qo-qty').removeAttribute('disabled');
            enableQtyUpdate();
        }
    }

    const clearErrMsg = () => {
        document.getElementById("invalidEstimationError").classList.remove("d-block")
        document.getElementById("invalidEstimationError").classList.add("d-none")
        document.getElementById("emptyMsg12").classList.remove("d-block")
        document.getElementById("emptyMsg12").classList.add("d-none")
        document.getElementById("shipping-estimate-zip").classList.remove("quantity-error")
    }

    const handleEstimateShipping = (event) => {
        event.preventDefault();
        clearErrMsg();
        setIsLoading(false)
        setHasError(false)
        var formData = new FormData(document.getElementById('shippingEstimateForm12'))
        var zip = formData.get("shipping-estimate-zip")
        const estimateZip = document.getElementById("shipping-estimate-zip").value
        if (zip == null || zip == "") {
            setHasError(true)
            document.getElementById("invalidEstimationError").classList.remove("d-block")
            document.getElementById("invalidEstimationError").classList.add("d-none")
            document.getElementById("emptyMsg12").classList.remove("d-none")
            document.getElementById("emptyMsg12").classList.add("d-block")
            document.getElementById("shipping-estimate-messaging").classList.remove("d-block")
            document.getElementById("shipping-estimate-messaging").classList.add("d-none")
            // document.getElementById("shipping-estimate-zip").setAttribute("class", "quantity-error")
            document.getElementById("shipping-estimate-zip").classList.add("quantity-error")
            setZipValue("estimate")
            //setZipValue(estimateZip && estimateZip.value  && "update")
        } else {
            var validation = /^(\d{5}|\d{5}-\d{4})$/
            var regex = RegExp(validation);
            if (!regex.test(zip)) {
                setHasError(true)
                document.getElementById("invalidEstimationError").classList.remove("d-none")
                document.getElementById("invalidEstimationError").classList.add("d-block")
                // document.getElementById("shipping-estimate-zip").setAttribute("class", "quantity-error")
                document.getElementById("shipping-estimate-zip").classList.add("quantity-error")
                // document.getElementById("shipping-estimate-messaging").classList.remove("d-block")
                // document.getElementById("shipping-estimate-messaging").classList.add("d-none")
                setZipValue(estimateZip && estimateZip && estimateZip != null ? "update" : "estimate")
            }
        }
        if (!hasErrorRef.current) {
            document.getElementById("loadingSectionAnimation").classList.remove("d-none")
            document.getElementById("loadingSectionAnimation").classList.add("d-block")
            document.getElementById("freight-loader").classList.remove("d-none")
            document.getElementById("freight-loader").classList.add("d-block")
            document.getElementById("shipping-estimate-messaging").classList.remove("d-block")
            document.getElementById("shipping-estimate-messaging").classList.add("d-none")
            if (document.getElementById("promo-discount") != null) {
                document.getElementById("promo-discount").classList.remove("visible")
                document.getElementById("promo-discount").classList.add("invisible")
            }
            document.getElementById("freight").classList.remove("visible")
            document.getElementById("freight").classList.add("invisible")
            document.getElementById("tax").classList.remove("visible")
            document.getElementById("tax").classList.add("invisible")
            document.getElementById("subtotal").classList.remove("visible")
            document.getElementById("subtotal").classList.add("invisible")

            const inputMap = {
                zipCodeInput: zip,
                actionType: "ShippingCharges"
            }

            fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/cart/zipCodeValidation`, {
                method: 'POST',
                headers: new Headers({
                    "content-Type": "application/json",
                }),
                body: JSON.stringify(inputMap)
            }).then(res => res.json())
                .then(res => {
                    if (res.result === "success") {
                        setEstimateShipping(JSON.parse(res.response))
                        document.getElementById("emptyCartMsg").classList.remove("d-block")
                        document.getElementById("emptyCartMsg").classList.add("d-none")
                        document.getElementById("shipping-estimate-zip").classList.remove("quantity-error")
                        document.getElementById("invalidEstimationError").classList.remove("d-block")
                        document.getElementById("invalidEstimationError").classList.add("d-none")
                        document.getElementById("emptyMsg12").classList.remove("d-block")
                        document.getElementById("emptyMsg12").classList.add("d-none")
                        document.getElementById("loadingSectionAnimation").classList.remove("d-block")
                        document.getElementById("loadingSectionAnimation").classList.add("d-none")
                        document.getElementById("freight-loader").classList.remove("d-block")
                        document.getElementById("freight-loader").classList.add("d-none")
                        document.getElementById("shipping-estimate-messaging").classList.remove("d-none")
                        document.getElementById("shipping-estimate-messaging").classList.add("d-block")
                        if (document.getElementById("promo-discount") != null) {
                            document.getElementById("promo-discount").classList.remove("invisible")
                            document.getElementById("promo-discount").classList.add("visible")
                        }
                        document.getElementById("freight").classList.remove("invisible")
                        document.getElementById("freight").classList.add("visible")
                        document.getElementById("tax").classList.remove("invisible")
                        document.getElementById("tax").classList.add("visible")
                        document.getElementById("subtotal").classList.remove("invisible")
                        document.getElementById("subtotal").classList.add("visible")
                        const estimateZip = document.getElementById("shipping-estimate-zip")
                        setZipValue(estimateZip && estimateZip.value && estimateZip.value != null ? "update" : "estimate")
                        // setIsLoading(true)
                    } else {
                        document.getElementById("shipping-estimate-zip").classList.add("quantity-error")
                        document.getElementById("loadingSectionAnimation").classList.remove("d-block")
                        document.getElementById("loadingSectionAnimation").classList.add("d-none")
                        document.getElementById("freight-loader").classList.remove("d-block")
                        document.getElementById("freight-loader").classList.add("d-none")
                        document.getElementById("emptyCartMsg").classList.remove("d-none")
                        document.getElementById("emptyCartMsg").classList.add("d-block")
                        if (document.getElementById("promo-discount") != null) {
                            document.getElementById("promo-discount").classList.remove("invisible")
                            document.getElementById("promo-discount").classList.add("visible")
                        }
                        document.getElementById("freight").classList.remove("invisible")
                        document.getElementById("freight").classList.add("visible")
                        document.getElementById("tax").classList.remove("invisible")
                        document.getElementById("tax").classList.add("visible")
                        document.getElementById("subtotal").classList.remove("invisible")
                        document.getElementById("subtotal").classList.add("visible")
                    }
                })
        }
    }
    const cartDetailsCallBack = (productDetails) => {
        //setCartList(productDetails)
        if (productDetails) {
            handleGetCartList()
        }
    }
    return (
        <>
            {isLoading && <Loader />}
            <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId}
                data-template-name={templateName} className={`cart-main vast-plugin-content c-shop-list-detail`}>

                <div className="row align-items-center justify-content-between">
                    <div className="col-md-11">
                    </div>
                    <div className="col-12 col-md-1 d-none d-lg-block">
                        <button className="btn btn-light c-print-btn text-end" onClick={handlePrintPage}>
                            <i className="fas fa-print"></i>Print
                        </button>
                    </div>
                </div>
                {restrictErrorMsgRef.current &&
                    <div className="alert alert-danger d-block" role="alert" id="pdp-promo-error">
                        <p dangerouslySetInnerHTML={{ __html: restrictErrorMsgRef.current ? restrictErrorMsgRef.current : '' }}>
                        </p>
                    </div>}
                <div className="mx-2">
                    <h1 className="col cart-heading">
                        Your Shopping Cart
                    </h1>
                </div>
                <div className="row cart-introduction">
                    <div className="col col-9">
                    </div>

                    {isPunchoutInspect ?
                        <div className="col col-3 text-end d-none d-md-block">
                            <a className={`btn ${!emptyCart ? "btn-primary" : "btn-disable"}`} href="https://staging.suppliersolutions.com/carolina/suppliers/carolina/receivecart.asp">EXIT CART</a>
                        </div>
                        :
                        profileDetail && profileDetail.userTypeCheck && Object.keys(profileDetail.userTypeCheck).length > 0 &&
                            profileDetail.userTypeCheck.user != "csr" && profileDetail.userTypeCheck.user != "imperson" && !isPunchoutInspect && profileDetail.userTypeCheck.punchoutClient ?
                            <div className="col col-3 text-end d-none d-md-block">
                                <button className={`btn ${!emptyCart ? "btn-primary" : "btn-disable"}`} onClick={handlePunchOutCheckOut}>SEND CART TO {profileDetail.userTypeCheck && profileDetail.userTypeCheck.punchoutClient}</button>
                            </div> : isPunchoutInspect ? <></> :
                                <div className="col col-3 text-end d-none d-md-block">
                                    <button className={`btn ${!emptyCart ? "btn-primary" : "btn-disable"}`} onClick={handleCheckOut}>{userTypeRef.current === 3 ? "Submit Quote Request" : "Checkout"}</button>
                                </div>
                    }
                </div>
                {discountEnableMsgRef.current ?
                    <div class="grid-container optional-messaging mb-md-4">
                        <div class="row cart-upper-messaging">
                            <div class="col-12 d-none">
                                <div class="alert alert-danger my-3" id="errorCart" role="alert">
                                    <p class="error">
                                        The operation could not be completed. We apologize for the inconvenience. Please create a new cart or contact  <a href="#">customer service</a> for assistance.
                                    </p>
                                </div>
                            </div>
                            <div class="col-12 col-md-10">

                                <p class="promotional-bcc-messaging mx-3 icon-content">
                                    <i class="bi bi-exclamation-circle-fill"></i>
                                    <span class="icon-text" dangerouslySetInnerHTML={{ __html: discountEnableMsgRef.current ? discountEnableMsgRef.current : '' }}></span>
                                </p>

                            </div>
                        </div>

                    </div> : <></>
                }
                <div className="mx-3 d-none d-md-flex">
                    <div className="col col-12 cart-items-link text-end">
                        {!isPunchoutInspect ? <Link to="" onClick={handleClickScroll} className="flR quick-order-link">Quick Order </Link> : ''}

                        {!emptyCart ? <>

                            {!isPunchoutInspect && !isPunchoutRef.current ? <Link id="add-cart-to-list" to={`${profileDetail && profileDetail.transient ? "/account/login" : "#newListModalww"}`} onClick={handleClearErrMsg} data-bs-toggle={`${profileDetail && profileDetail.transient ? "" : "modal"}`} data-bs-dismiss={`${profileDetail && profileDetail.transient ? "" : "modal"}`} className="add-to-list-link"> Add Shopping Cart to List </Link> : ''}
                            <Link className="print-link" onClick={handlePrintPage}>Print</Link> </> : ""}
                    </div>
                </div>
                {/* <ProductRestrictionModal /> */}
                {/* <Link data-bs-toggle="modal" data-bs-target="#newListModalww" className="btn btn-secondary cb-bth-secondary flex-end pdp-order-list modal-list">Add to List...1</Link> */}
                <AddShoppingListModal commerceId={commerceIdListJoin ? commerceIdListJoin : ""} productId={productListJoin ? productListJoin : ""} />
                {/* Add to shopping List modal */}
                <div className="modal gx-0 fade c-shopping-list-modal-body" id="AddShoppingCart" tabindex="-1" aria-labelledby="addToListModal" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-fullscreen-sm-down modal-lg-a">
                        <div className="modal-content">
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            <div className="modal-body">
                                <div className="container-fluid addToList-modal-body">
                                    <div className="row align-items-center">
                                        <div className="col-auto">
                                            <h1 className="modal-title mt-1" id="defaultModalLabel">Add to List</h1>
                                            <p className="modal-subheading">Save this item for later by adding it to a shopping list.</p>
                                        </div>

                                        <ul className="col-12 list-unstyled addToList-items">
                                            <li className="addToList-item">
                                                <div className="form-check">
                                                    <input className="form-check-input" type="checkbox" id="gl17524664" name="check" />
                                                    <label className="row form-check-label" for="gl17524664">
                                                        <span className="col-6 list-title">29/12/23</span>
                                                        <span className="col-6 list-date text-end">Created 12/29/2023</span>
                                                        <span className="col-12 list-desc"></span>
                                                    </label>
                                                </div>
                                            </li>

                                            <li className="addToList-item">
                                                <div className="form-check">
                                                    <input className="form-check-input" type="checkbox" name="check" id="new-list" />
                                                    <label className="row form-check-label" for="new-list">
                                                        <span className="col-12 list-title">Add a New List</span>
                                                    </label>
                                                </div>
                                                <div className="form">
                                                    <div className="row mb-3 align-items-center">
                                                        <label for="eventName" className="col-3 col-md-3 col-form-label">List Name:</label>
                                                        <div className="col-9 col-md-7">
                                                            <input type="text" maxlength="40" className="form-control" id="eventName" />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <label for="newDescription" className="col-3 col-md-3  col-form-label">List Description:</label>
                                                        <div className="col-9 col-md-7">
                                                            <textarea className="form-control c-list-description" maxlength="120" id="newDescription" rows="3"></textarea>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>

                                        </ul>
                                        <div className="row justify-content-end form-submit">
                                            <div className="col-auto">
                                                <input type="submit" className="col-auto btn btn-primary" value="Save Item" />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div id="cart-title" ref={errorDivRef} className="cart-details">
                    <div className="cart-header d-none d-md-flex px-2">
                        <div className="col-12 col-md-6 col-lg-7"> Item Information</div>
                        <div className="col cart-header-price">{!emptyCart && profileDetail && profileDetail.hidePrice && profileDetail.hidePrice === "false" ? "Item Price" : ""}</div>
                        <div className="col text-center">Qty</div>
                        <div className="col text-center text-md-end">{profileDetail && profileDetail.hidePrice && profileDetail.hidePrice === "false" ? "Total" : ""}</div>
                    </div>
                </div>

                {!emptyCart && cartDetails && cartDetails.length > 0 ? cartDetails.map((value, key) => {
                    { console.log("single product..", value) }

                    return (
                        (value.productId && value.productId != null &&
                            <div className="cart-item-list" key={value.commerceId} id={`cart-item-row_${value.productId}`} data-proid={`${value.productId}`}>
                                <div className="row d-flex mx-1">
                                    <div className='col-12 col-md-6 col-lg-7'>
                                        <div className='row align-items-center'>
                                            {!isPunchoutInspect ?
                                                <div className='col-auto cart-remove-item cart-item-delete d-none d-md-block' onClick={(event) => handleRemoveOneItem(value.commerceId)}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                                                        <path d="M8,1C4.1,1,1,4.1,1,8c0,3.9,3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M11.5,10.4l-1.1,1.1c-0.1,0.1-0.3,0.1-0.4,0l-2-2l-2,2 c-0.1,0.1-0.3,0.1-0.4,0l-1.1-1.1c-0.1-0.1-0.1-0.3,0-0.4l2-2l-2-2c-0.1-0.1-0.1-0.3,0-0.4l1.1-1.1c0.1-0.1,0.3-0.1,0.4,0l2,2l2-2 c0.1-0.1,0.3-0.1,0.4,0l1.1,1.1c0.1,0.1,0.1,0.3,0,0.4l-2,2l2,2C11.6,10.1,11.6,10.3,11.5,10.4z"></path>
                                                    </svg>
                                                </div>
                                                : <></>
                                            }

                                            <div className='col-auto cart-item-img'>
                                                {isPunchoutInspect ?
                                                    <img alt="/images/fpo/product-140x140.gif" onError={replaceImage} src={`${value.ImageURL}`} />
                                                    :
                                                    <Link to={`${value.productUrl}`}>
                                                        <img alt="/images/fpo/product-140x140.gif" onError={replaceImage} src={`${value.ImageURL}`} />
                                                    </Link>
                                                }
                                            </div>
                                            <div className="col-6 flex-fill cart-item-info">
                                                {isPunchoutInspect ?
                                                    <p className="d-block punchout-display-name">
                                                        <span className="cart-item-title" dangerouslySetInnerHTML={{ __html: value.displayName }}></span>
                                                        <span className="cart-item-title">{`#${value.productId}`}</span>
                                                    </p>
                                                    :
                                                    <Link className="d-block" to={`${value.productUrl}`}>
                                                        <span className="cart-item-title" dangerouslySetInnerHTML={{ __html: value.displayName }}></span>
                                                        <span className="cart-item-title">{`#${value.productId}`}</span>
                                                    </Link>

                                                }

                                                <div className="cart-item-desc">
                                                    <div className="cart-item-stock fwb">{`${value.invMessageToShowInSPCCart ? value.invMessageToShowInSPCCart : value.invMessageToShowInCart ? value.invMessageToShowInCart : ''}`}</div>
                                                    {value.defaultShipMethod && value.defaultShipMethod &&
                                                        <div class="cart-item-shipping">
                                                            {/* onMouseEnter={value.ProductId && handleMouseEnter1} onMouseLeave={value.ProductId && handleMouseLeave1} */}
                                                            <span>Shipping: </span>
                                                            {value && value.shippingMethodOnHoverMessage ?
                                                                <Link role="button" className="c-tooltip" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-html="true">
                                                                    <span onMouseLeave={() => handlePromoHoverLeave(value.productId)} onMouseEnter={() => handlePromoHoverEnter(value.productId)}>{`${value.defaultShipMethod}`}</span>
                                                                    <span id={`${value.productId}`} className="c-tooltip m d-none"
                                                                        style={{ position: 'relative' }}>
                                                                        <div style={{
                                                                            position: 'absolute',
                                                                            top: '5px',
                                                                            left: '20px',
                                                                            backgroundColor: '#fbf3bf',
                                                                            color: '#333',
                                                                            padding: '10px',
                                                                            borderRadius: '3px',
                                                                            zIndex: '1',
                                                                            width: '200px',
                                                                            height: 'auto',
                                                                            fontSize: '0.75rem',
                                                                            fontWeight: '400',
                                                                            border: "0.063rem solid #ccc",
                                                                            boxShadow: "0 0 0.625rem #ccc",
                                                                            lineHeight: "1.125rem",
                                                                            borderRadius: "0.313rem",
                                                                            textAlign: "center"
                                                                        }}>
                                                                            <div style={{
                                                                                position: 'absolute', top: '-7px', left: '40%', marginLeft: '10px', width: '0', height: '0',
                                                                                borderLeft: '5px solid transparent', borderRight: '5px solid transparent', borderBottom: '7px solid #333',
                                                                            }}></div>
                                                                            {value && value.shippingMethodOnHoverMessage}
                                                                        </div>
                                                                        {/* )} */}
                                                                    </span>
                                                                </Link> :
                                                                <Link role="button" className="c-tooltip" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-html="true">
                                                                    <span>{`${value.defaultShipMethod}`}</span>
                                                                </Link>
                                                            }
                                                        </div>}
                                                    {value && value.propsWarningMessageMessageLinkText &&
                                                        <div class="cart-item-warning">
                                                            <span class="cart-item-shipping">
                                                                California customers: <Link data-bs-toggle="modal" data-bs-target="#prop65-modal-228424">{value.propsWarningMessageMessageLinkText}</Link>
                                                            </span>
                                                        </div>
                                                    }
                                                    <div className="d-md-none mobileRemove">
                                                        <input type="hidden" id="ciId" value="ci2687004979" />
                                                        {/* <Link to="" className="cart-remove-link fst-italic">Remove</Link> */}
                                                        <Link onClick={() => handleRemoveOneItem(value.commerceId)} className="cart-remove-link fst-italic">Remove</Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col">
                                        <div className="row">
                                            <div className="col-12 order-2 order-md-1">
                                                <div className="row g-mob-0 p-1 d-md-none">
                                                    <div className="col text-center order-2 order-md-1">
                                                        <div className="cart-item-heading-label d-md-none">
                                                            <span>Your Price</span>
                                                        </div>
                                                    </div>
                                                    <div className="col cart-item-heading-qty text-center order-1 order-md-2">
                                                        <div className="cart-item-heading-label d-md-none">
                                                            <span>Qty</span>
                                                        </div>
                                                    </div>
                                                    <div className="col text-center text-md-end order-3">
                                                        <div className="cart-item-heading-label d-md-none">
                                                            <span>Item Total</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 order-3 order-md-2">

                                                <div className="row g-mob-0 p-1 p-md-0 cart-item-values align-items-baseline">
                                                    <div className="col cart-item-price order-2 order-md-1">
                                                        {profileDetail && profileDetail.hidePrice && profileDetail.hidePrice === "false" && value && !value.basePrice && !value.contractPrice || isPunchoutInspect ||
                                                            isPunchoutRef.current ?
                                                            <div className='cart-retail-price d-md-inline'>{console.log("cart=1691", !value.basePrice)}
                                                                <span className='cart-contract-price'>{value.listPrice ? value.listPrice : value.salePrice ? value.salePrice : '$0.00'}</span>
                                                            </div>
                                                            :
                                                            profileDetail && profileDetail.hidePrice && profileDetail.hidePrice === "false" && value && !value.basePrice && value.contractPrice &&
                                                                userTypeRef.current && userTypeRef.current !== 2 ?
                                                                <>
                                                                    <div className='cart-retail-price d-md-inline'>
                                                                        <span className='cart-item-original-price me-md-1 retail-price retail-price-label'>
                                                                            {value.listPrice ? value.listPrice : value.salePrice ? value.salePrice : ''}
                                                                        </span>
                                                                    </div>
                                                                    <span className='cart-contract-price'>{value.contractPrice ? value.contractPrice : '$0.00'}</span>
                                                                </>
                                                                :
                                                                profileDetail && profileDetail.hidePrice && profileDetail.hidePrice === "false" ?
                                                                    <div className='cart-item-contract-price'>{console.log("cart=1705")}
                                                                        {value.basePrice && <span className='cart-contract-label d-md-inline d-none'>{value.priceTitle && value.priceTitle} </span>}
                                                                        <span className='cart-contract-price'>{value.listPrice ? value.listPrice : value.salePrice ? value.salePrice : value.contractPrice ? value.contractPrice : '$0.00'}</span>

                                                                        {userTypeRef.current && value.basePrice && userTypeRef.current === 2 ? <>
                                                                            <div className='cart-retail-price d-md-block d-none'>
                                                                                <span className='retail-price-label'>{value.retailPriceTitle && value.retailPriceTitle} </span>
                                                                                <span className='cart-item-original-price retail-price'>{value.basePrice && value.basePrice}</span>
                                                                            </div>

                                                                        </>
                                                                            : ""}
                                                                    </div> : ""
                                                        }


                                                    </div>

                                                    {/* <!-- closing of col cart-item-price order-2 order-md-1 --> */}
                                                    <div className="col text-center order-1 order-md-2 cart-item-quantity">
                                                        <input type="hidden" id="ciId" value="ci2687004979" />
                                                        <div className="input-group c-input-group">
                                                            <button type="button" className="button-minus d-md-none"
                                                                onClick={() => { handleIncrementDecrement(value.commerceId, productQtyRef.current[value.commerceId], 'decrement') }}
                                                                data-field="cart-item-quantity" aria-label="decreament the quantity">
                                                                <i class="fas fa-minus"></i>
                                                            </button>
                                                            {isPunchoutInspect ?
                                                                <div className='col text-center order-1 order-md-2 cart-item-quantity'>
                                                                    <div className='text-center'>
                                                                        <span className='fw-bold'>{productQtyRef.current[value.commerceId]}</span>
                                                                    </div>
                                                                </div>
                                                                :
                                                                <input id={'qty-' + value.commerceId} name="cart-item-quantity" type="text" data-lastval="" value={productQtyRef.current[value.commerceId]} onClick={() => document.getElementById('qty-' + value.commerceId).select()}
                                                                    onChange={(event) => handleOnChangeQty(event, value.commerceId)} maxlength="3" max="999"
                                                                    className="cart-item-quantity-input form-control quantity-field" tabindex="1" />
                                                            }

                                                            <button type="button" className="button-plus d-md-none" data-field="cart-item-quantity"
                                                                onClick={() => { handleIncrementDecrement(value.commerceId, productQtyRef.current[value.commerceId], 'increment') }}
                                                                aria-label="increament the quantity">
                                                                <i class="fas fa-plus"></i>
                                                            </button>
                                                        </div>
                                                        <a className='cart-item-quantity-remove d-none' id={'remove-product-' + value.commerceId} onClick={(event) => handleRemoveOneItem(value.commerceId)}>remove</a>
                                                    </div>
                                                    <div className="col text-center text-md-end order-3">
                                                        {profileDetail && profileDetail.hidePrice && profileDetail.hidePrice === "false" ?
                                                            <><span id={"cart-item-total" + value.commerceId} className="cart-item-total">{`${value.total}`}</span>
                                                                <div id={"qty-total-loader" + value.commerceId} className="cartTotalloadingAnimation d-none">
                                                                    <span className="spinner-border" role="status" aria-hidden="true"></span>
                                                                    <span className="visually-hidden">Loading...</span>
                                                                </div></> : ""
                                                        }

                                                    </div>
                                                </div>


                                                {/* <!-- closing of row g-mob-0 p-1 p-md-0 cart-item-values align-items-baseline --> */}
                                            </div>
                                            <div class="col-12 order-1 order-md-3">
                                                <div class="row">
                                                    <div class="col cart-item-addl-info text-md-center">

                                                        <p class={`advanced-error field-error ${value.stockAlertMessage ? "d-block" : "d-none"}`}>{value.stockAlertMessage}</p>
                                                        {value.saveMsg && <div class="icon-content justify-content-center mt-2">
                                                            <i class="bi bi-exclamation-circle-fill c-l-green"></i>
                                                            <span class="icon-text text-start">
                                                                <strong class="c-l-green d-block">
                                                                    You can save even more
                                                                </strong>
                                                                {value.saveMsg}
                                                            </span>
                                                        </div>}
                                                        {hasScrollView && (
                                                            <p className="review-error field-error mt-3">
                                                                The following product(s) can only be sold and shipped to authorized schools or businesses. Please remove items from your order and proceed with checkout. Many restricted products have substitution options available. Please call 800.334.5551 for assistance with substitution items.
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            {/* <!-- closing of col-12 order-3 order-md-2 --> */}

                                        </div>
                                        {/* <!-- closing of row g-0 --> */}
                                    </div>
                                </div>
                            </div>)
                    )
                }) :
                    <div className="row empty-cart">
                        <div className="col-12">
                            <p>
                                Your cart is currently empty
                            </p>
                        </div>
                    </div>}



                <div className="row cart-footer mx-0">
                    {!emptyCart && !isPunchoutInspect &&
                        <div className="col-6 cart-remove-item">
                            <Link onClick={(event) => handleRemoveItem(event)}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                                    <path d="M8,1C4.1,1,1,4.1,1,8c0,3.9,3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M11.5,10.4l-1.1,1.1c-0.1,0.1-0.3,0.1-0.4,0l-2-2l-2,2 c-0.1,0.1-0.3,0.1-0.4,0l-1.1-1.1c-0.1-0.1-0.1-0.3,0-0.4l2-2l-2-2c-0.1-0.1-0.1-0.3,0-0.4l1.1-1.1c0.1-0.1,0.3-0.1,0.4,0l2,2l2-2 c0.1-0.1,0.3-0.1,0.4,0l1.1,1.1c0.1,0.1,0.1,0.3,0,0.4l-2,2l2,2C11.6,10.1,11.6,10.3,11.5,10.4z"></path>
                                </svg> <span>remove all items</span>
                            </Link>
                        </div>}
                    {!emptyCart ?
                        <div className="col-6 d-md-none cart-item-save">
                            {userTypeRef.current && userTypeRef.current.transient === true ?
                                <Link to="/account/login" className="flR">Save Cart</Link>
                                :
                                <Link id="flR add-cart-to-list" to="#newListModalww" onClick={handleClearErrMsg} data-bs-toggle="modal" data-bs-dismiss="modal" className="add-to-list-link">Save Cart</Link>

                            }

                        </div> : ""}
                </div>

                {/* quik order section */}

                <div className="row my-md-5 pb-md-4">
                    {isPunchoutInspect ? <></> :
                        <>
                            <div className="col-12 col-md-7 col col-lg-6 mb-md-2 cb-quick-order quick-order">
                                {console.log('isPunchoutInspect...inside quickorder...', isPunchoutInspect)}
                                <form onSubmit={handleQuickOrder}>
                                    <div id="quick-order" className="row form cb-cart-quick-order">
                                        <div className="cart-quick-order px-4">
                                            <h3 className="quick-order-title d-block d-md-none">Quick Order:</h3>
                                            <div className="alert alert-danger error row error-messaging d-none" id="quick-order-error">
                                                <p>{cartQuantityErrorMsgRef.current && cartQuantityErrorMsgRef.current}</p>
                                            </div>
                                            <div className="row align-items-md-baseline">

                                                <div className="col-md-3">
                                                    <h3 className="quick-order-title d-none d-md-block">Quick Order:</h3></div>

                                                <div className="col col-md-5 order-3 order-md-2 p-0">
                                                    <div className="d-flex">
                                                        <input name="catalogRefId" id="qo-item-id" placeholder="enter item number" type="text" className="form-control item-number" onChange={changeToUpperCase} />
                                                        <input maxlength="3" name="quantity" id="qo-qty" type="text" defaultValue="1"
                                                            onChange={RestrictFirstZero} className="form-control item-quantity" />
                                                    </div>
                                                    {/* <span className={`${cartQuantityErrorMsgRef.current && cartQuantityErrorMsgRef.current ? "d-block" : "d-none"} field-error quick-order-error`}>
                                            {cartQuantityErrorMsgRef.current && cartQuantityErrorMsgRef.current ? cartQuantityErrorMsgRef.current : ""}</span> */}
                                                    <span id="quickOrderError" className="field-error quick-order-error d-none">Enter valid item or qty</span>
                                                </div>
                                                <div className="item-add col-auto order-4 order-md-3">
                                                    <input id="addToCart" type="submit" value="add item" className="btn btn-secondary" />
                                                </div>


                                                <div class="col-12 col-md-auto order-2 order-md-4 loadingSectionAnimation text-center mb-2 mb-md-0 d-none" id="addToCartLoading" wfd-invisible="true" >
                                                    <span class="spinner-border" role="status" aria-hidden="true"></span>
                                                    <span class="visually-hidden">Loading...</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </form>
                            </div>
                            {/* <!-- Hide the data for punchout users --> */}
                            <div id="security" className="col-12 col-md-5 col-lg-6 security">
                                <div className="row">
                                    <div className="col-12 col-md-7 offset-md-5">
                                        <div className="security-message d-none d-lg-block d-md-block d-flex align-items-center justify-content-center justify-content-md-start">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                                                <g> <path d="M8,1C5.4,1,3.4,3,3.4,5.5v2.1H2.5V15h10.9V7.5h-0.8V5.5C12.6,3,10.6,1,8,1z M8,3c1.4,0,2.6,1.1,2.6,2.5v2.1H5.4V5.5 C5.4,4.1,6.6,3,8,3z">
                                                </path> </g>
                                            </svg>
                                            <span> Shopping is always safe and secure  </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                </div>

                <div className="row">
                    {/* <!-- Hide the account benefits section for punchout users CBSUPG-1563--> */}
                    <div className="col-12 col-md-6 order-2 order-md-1 d-none d-md-block">
                        {userTypeRef.current && userTypeRef.current.transient === true ?
                            <div className="cart-messaging hifi-anon" id="account-benefits">
                                <h3 className="h4">{headMsgRef.current && headMsgRef.current.headMsg}</h3>
                                <p>{headMsgRef.current && headMsgRef.current.benefitsMsg}</p>
                                <ul dangerouslySetInnerHTML={{ __html: headMsgRef.current && headMsgRef.current.taxMsg }}>
                                </ul>
                                <p><em>{headMsgRef.current && headMsgRef.current.alreadyMemberMsg} <Link to="/account/login?resume=prev"><span onClick={() => { dispatch(redirectUrlAction('/checkout/cart')) }}>{headMsgRef.current && headMsgRef.current.SigninMsg}</span> </Link>{headMsgRef.current && headMsgRef.current.priceMsg}</em></p>

                                <Link to="/account/login?resume=prev" className="btn btn-secondary">{headMsgRef.current && headMsgRef.current.createAccountMsg}</Link>
                            </div>
                            :
                            (userTypeRef.current === 2) ?
                                <div id="account-benefits2" className="cart-messaging hifi-b2i">
                                    {console.log("contractTermsRef.current", contractTermsRef.current)}
                                    <h3 class="h4">{headMsgRef.current && headMsgRef.current.accountBenefit1Msg}</h3>
                                    <div class="row">
                                        <div class="col col-4"><p>{headMsgRef.current && headMsgRef.current.spendLimitMsg}</p></div>
                                        <div class="col col-8"> <p>{headMsgRef.current && headMsgRef.current.orderPriceLimitMsg}</p></div>
                                    </div>
                                    <div class="row">
                                        <div class="col col-4"><p>{headMsgRef.current && headMsgRef.current.taxExemptMsg}</p></div>
                                        <div class="col col-8"><p>{headMsgRef.current && headMsgRef.current.taxExemptCartMsg}</p></div>
                                    </div>
                                    <div class="row">
                                        <div class="col col-4"><p>{headMsgRef.current && headMsgRef.current.b2iPoMsg}</p></div>
                                        <div class="col col-8"><p>{headMsgRef.current && headMsgRef.current.isPoElligibleCartMsg}</p></div>
                                    </div>
                                    <div class="row">
                                        <div class="col col-4"><p>{headMsgRef.current && headMsgRef.current.b2iContractMsg}</p></div>
                                        <div class="col col-8" dangerouslySetInnerHTML={{ __html: headMsgRef.current && headMsgRef.current.contractTerms }}>
                                        </div>
                                    </div>
                                    <p></p>
                                    <p class="profile-contract-disclaimer"></p>
                                </div>
                                : ""}
                    </div>

                    <div className="col-12 col-md-6 order-1 order-md-2">
                        <div className="cart-totals mx-2">
                            {/* <!-- Hide promo codes for punchout users CBSUPG: 1565 and Hide shipping estimate for punchout user CBSUPG-1567 --> */}
                            {userTypeRef.current && userTypeRef.current != 3 &&
                                <div id="promotional-code-div" className="cart-accordion">
                                    <div className="promotional-code-form accordion-item cart-promotional">
                                        <div id="promotional" className="">
                                            <form id="applyPromotionCode2" data-hs-cf-bound="true">
                                                <div className="row promotional-code">
                                                    <div className="col-12 col-md-5">
                                                        {/* <div>
                                                            <span className={`${PromotionalCodeErrorMsgRef.current && PromotionalCodeErrorMsgRef.current ? "d-block" : "d-none"} alert alert-danger error`}>
                                                                <p dangerouslySetInnerHTML={{ __html: PromotionalCodeErrorMsgRef.current }}></p></span>
                                                        </div> */}
                                                        {/* <div class="col-12 col-md-5"> */}
                                                        <div class="promotional-code-messaging messaging mx-1">
                                                            <div id="promotional-code-messaging" class={`alert alert-secondary success ${discountMessageRef.current || estimateShippingRef.current && estimateShippingRef.current.discountMessage ? "d-block" : "d-none"}`} role="alert">
                                                                <p>{discountMessageRef.current ? discountMessageRef.current : estimateShippingRef.current && estimateShippingRef.current.discountMessage}</p>
                                                            </div>
                                                            <div id="promo-error" className="d-none alert alert-danger error" role="alert">
                                                                <p dangerouslySetInnerHTML={{ __html: PromotionalCodeErrorMsgRef.current }}></p>
                                                            </div>
                                                        </div>
                                                        <div class="loadingSectionAnimation text-center text-md-end mb-2">
                                                            <span class="spinner-border" role="status" aria-hidden="true"></span>
                                                            <span class="visually-hidden">Loading...</span>
                                                        </div>
                                                        {/* </div> */}
                                                        <div id="loadingSectionAnimationPromo" className="loadingSectionAnimationPromo text-center text-md-end mb-2 d-none">
                                                            <span className="spinner-border" role="status" aria-hidden="true"></span>
                                                            <span className="visually-hidden">Loading...</span>
                                                        </div>
                                                    </div>
                                                    <div className="col-12 col-md-7 promotional-code-form">
                                                        <label className="form-label d-block d-md-block mx-1">
                                                            Apply a Promotional Code
                                                        </label>
                                                        <div className="row col-lg-12 col-mx-12">
                                                            <form id="promo-form" className="d-flex promo-form" onSubmit={handlePromotionalCode} data-hs-cf-bound="true" >
                                                                <div class="col-lg-9 col-9 col-md-8 mx-md-1 mx-lg-1">
                                                                    {console.log("promotionIdRef.current", promotionIdRef.current)}
                                                                    {console.log("estimateShippingRef.current.promotionId", estimateShippingRef.current && estimateShippingRef.current.promotionId)}
                                                                    <input id="promotional-code" name="promotional-code" type="text" defaultValue={promotionIdRef.current || estimateShippingRef.current && estimateShippingRef.current.promotionId} className="form-control promotional-code" placeholder="enter promo code" onChange={handlePromoChange} />
                                                                </div>
                                                                <div class="col-lg-3 col-3">
                                                                    <button id="promotional-code-submit" value={promoValue && promoValue} type="Submit" className="btn btn-secondary submit" >{promotionIdInvalidRef.current ? "apply code" : promotionIdRef.current || estimateShippingRef.current && estimateShippingRef.current.promotionId ? "change code" : "apply code"}</button>
                                                                </div>
                                                            </form>
                                                        </div>
                                                        <span id="emptyMsgPromo" className="emptyMsg error field-error d-none">You did not enter a promotion code</span>
                                                        {promotionIdRef.current || estimateShippingRef.current && estimateShippingRef.current.promotionId ?
                                                            <a onClick={handleRemoveCode} id="promo-remove" class={`promotional-code-remove link-underline mx-1`} style={{ 'cursor': 'pointer', "width": "28%" }}>remove code</a>
                                                            : ""}

                                                    </div>
                                                </div>
                                            </form>

                                        </div>
                                    </div>
                                </div>}
                            {userTypeRef.current && userTypeRef.current != 3 && !isPunchoutInspect ?
                                <div className="row shipping-estimate" id="shipping-estimate">
                                    <div className="col-12 col-md-5 order-1 order-md-0 mt-2 mt-md-0">
                                        <div id="shipping-estimate-messaging" class={`shipping-estimate-messaging messaging mx-1 ${estimateShippingRef.current && estimateShippingRef.current.shipMessagetoFormat ? "d-block" : "d-none"}`} >
                                            <div class="alert alert-secondary success" role="alert">{estimateShippingRef.current && estimateShippingRef.current.shipMessagetoFormat}</div>
                                        </div>
                                        <div id="loadingSectionAnimation" className="loadingSectionAnimation text-center text-md-end mb-2 d-none">
                                            <span className="spinner-border" role="status" aria-hidden="true"></span>
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-7 order-0 order-md-1">
                                        <label className="form-label mx-1">Estimate Shipping</label>
                                        <div class="row col-lg-12 col-md-12">
                                            <form id="shippingEstimateForm12" className="d-flex shipping-estimate-form" onSubmit={handleEstimateShipping} data-hs-cf-bound="true">
                                                <div class="col-lg-9 col-9 col-md-8 mx-md-1 mx-lg-1">
                                                    <input id="shipping-estimate-zip" name="shipping-estimate-zip" defaultValue={estimateShippingRef.current && estimateShippingRef.current.zipCode} type="text" tabindex="10" maxlength="10" className="form-control shipping-estimate-zip" placeholder="enter zip code" />
                                                </div>
                                                <div class="col-lg-2 col-3">
                                                    <button id="shipping-estimate-zip-submit" type="submit" value={zipValue && zipValue} className="btn btn-secondary submit" wfd-id="id136">{zipValue && zipValue}</button>
                                                </div>
                                            </form>
                                        </div>
                                        <span id="emptyMsg12" className="emptyMsg error field-error d-none">You did not enter a zip code</span>
                                        <span id="invalidEstimationError" className="invalidMsg error field-error d-none">The zip code entered is not valid</span>
                                        <span id="emptyCartMsg" className="emptyCartMsg error field-error d-none">Please add at least one item in cart</span>
                                    </div>
                                </div>
                                : ""}

                            <div className="totals-area pt-md-4">
                                <div className="cartSubtoltal">
                                    {userTypeRef.current && userTypeRef.current != 3 ? <>
                                        <div id="freight-loader" className="cartTotalloadingAnimation d-none">
                                            <span className="spinner-border" role="status" aria-hidden="true"></span>
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                        {estimateShippingRef.current && estimateShippingRef.current.discountAmount &&
                                            < div id="promo-discount" class="row totals-line promotion align-items-baseline">
                                                <div class="col-7 cart-charge">
                                                    Promotional Discount:
                                                </div>
                                                <div class="col-5 cart-charge-value c-red">- {estimateShippingRef.current && estimateShippingRef.current.discountAmount}</div>
                                            </div>
                                        }
                                        <div id="freight" className="row totals-line freight align-items-baseline">
                                            <div className="col-7 cart-charge">
                                                <span className="cart-tooltip">
                                                    {/* <button type="button" className="cart-tooltip-icon" data-bs-toggle="tooltip" data-bs-html="true"
                                                        title="Contract Customers: Freight & Handling is calculated based on your destination and product weight,and we then apply applicable freight discounts. 
                                            Non-Contract Customers:Freight & Handling is calculated based on your destination and product weight.
                                            Alaska & Hawaii Customers:All orders are shipped via 2nd Day Air.">
                                                        <i className="fas fa-question-circle"></i>
                                                    </button> */}
                                                    <span className="c-tooltip m" onMouseEnter={handleMouseEnter}
                                                        onMouseLeave={handleMouseLeave}
                                                        style={{ position: 'relative', margin: '5px' }}>
                                                        <i className="bi bi-question-circle-fill"></i>
                                                        {showTooltip && (
                                                            <div className="cart-freight-tooltip" style={{
                                                                position: 'absolute', top: '-130px', left: '-210px', zIndex: '1', width: '200px', padding: '0.875rem',
                                                                backgroundColor: '#fbf3bf', border: '0.063rem solid #ccc', boxShadow: '0 0 0.625rem #ccc', lineHeight: '1.125rem',
                                                                letterSpacing: '0', color: '#333', borderRadius: '0.313rem', textAlign: 'left',
                                                                fontSize: '0.75rem', fontWeight: '400'
                                                            }}>
                                                                <div className="cart-freight-tooltip-arrow" style={{
                                                                    position: 'absolute', top: '130px', left: '108%', marginLeft: '-15px', width: '0', height: '0',
                                                                    borderTop: '5px solid transparent', borderBottom: '5px solid transparent', borderLeft: '7px solid #333',
                                                                }}></div>
                                                                <strong>Contract Customers:</strong> Freight & Handling is calculated based on your destination and product weight,and we then apply applicable freight discounts.
                                                                <strong> Non-Contract Customers:</strong> Freight & Handling is calculated based on your destination and product weight.
                                                                <strong> Alaska & Hawaii Customers:</strong> All orders are shipped via 2nd Day Air.
                                                            </div>
                                                        )}
                                                    </span>
                                                    <span>Freight &amp; Handling:</span>
                                                    {/* <span id="shippingCost" >{estimateShippingRef.current && estimateShippingRef.current.shipping}</span> */}
                                                </span>
                                            </div>
                                            <div className="col-5 cart-charge-value value">
                                                <span className={`${estimateShippingRef.current && !estimateShippingRef.current.shipping
                                                    && (estimateShippingRef.current && estimateShippingRef.current.noPreviousZipCodeMsgForShipping
                                                        || userTypeRef.current && userTypeRef.current.transient) ? "anonymous" : ""}`}>
                                                    <s>{estimateShippingRef.current && estimateShippingRef.current.nonContractShipping ? estimateShippingRef.current.nonContractShipping : ""}  </s>
                                                    {estimateShippingRef.current && estimateShippingRef.current.punchoutFreightMsg ? estimateShippingRef.current.punchoutFreightMsg :
                                                        estimateShippingRef.current && estimateShippingRef.current.shipping ? estimateShippingRef.current.shipping :
                                                            estimateShippingRef.current && estimateShippingRef.current.shippingTotal ? estimateShippingRef.current.shippingTotal :
                                                                estimateShippingRef.current && estimateShippingRef.current.noPreviousZipCodeMsgForShipping ?
                                                                    <span>{estimateShippingRef.current.noPreviousZipCodeMsgForShipping.split("login") && estimateShippingRef.current.noPreviousZipCodeMsgForShipping.split("login")[0]} <Link to="/account/login?resume=prev"><strong> login</strong></Link></span> :
                                                                    userTypeRef.current && userTypeRef.current.transient &&
                                                                    <span>Estimate above or <Link to="/account/login?resume=prev"><span onClick={() => { dispatch(redirectUrlAction('/checkout/cart')) }}>login</span></Link></span>}
                                                </span>
                                            </div>
                                        </div> </> : <></>}
                                    {/* <!-- Hiding hazmat charge for punchout users CBSUPG:1566-->  */}
                                    {estimateShippingRef.current && estimateShippingRef.current.hazMatCharge ?
                                        < div class="row totals-line align-items-baseline hazmat">
                                            <div class="col-7 cart-charge">
                                                <span class="cart-tooltip">
                                                    <span className="c-tooltip m" onMouseEnter={handleMouseEnter2}
                                                        onMouseLeave={handleMouseLeave2}
                                                        style={{ position: 'relative', margin: '5px' }}>
                                                        <i className="bi bi-question-circle-fill"></i>
                                                        {showTooltip2 && (
                                                            <div className="cart-hazmat-tooltip" style={{
                                                                position: 'absolute', top: '-30px', left: '-210px', zIndex: '1', width: '200px', padding: '0.875rem',
                                                                backgroundColor: '#fbf3bf', border: '0.063rem solid #ccc', boxShadow: '0 0 0.625rem #ccc', lineHeight: '1.125rem',
                                                                letterSpacing: '0', color: '#333', borderRadius: '0.313rem', textAlign: 'left',
                                                                fontSize: '0.75rem', fontWeight: '400'
                                                            }}>
                                                                <div className="cart-hazmat-tooltip-arrow" style={{
                                                                    position: 'absolute', top: '30px', left: '108%', marginLeft: '-15px', width: '0', height: '0',
                                                                    borderTop: '5px solid transparent', borderBottom: '5px solid transparent', borderLeft: '7px solid #333',
                                                                }}></div>
                                                                {estimateShippingRef.current.hazMatChargeMsg}
                                                            </div>
                                                        )}
                                                    </span>
                                                    <span> Hazmat:</span>
                                                </span>
                                            </div>
                                            <div class="col-5 cart-charge-value">
                                                <span>{estimateShippingRef.current.hazMatCharge}</span>
                                            </div>
                                        </div>
                                        : ""}
                                    {userTypeRef.current && userTypeRef.current != 3 ?
                                        <div id="tax" className="row totals-line tax align-items-baseline">
                                            <div className="col-7 cart-charge">
                                                <span className="cart-tooltip">
                                                    {/* <button className="cart-tooltip-icon" data-bs-toggle="tooltip" data-bs-placement="left" data-bs-html="true"
                                                        title="Tax will be calculated according to your shipping zip code.">
                                                        <i className="fas fa-question-circle"></i>
                                                    </button> */}
                                                    <span className="c-tooltip m" onMouseEnter={handleMouseEnter1}
                                                        onMouseLeave={handleMouseLeave1}
                                                        style={{ position: 'relative', margin: '5px' }}>
                                                        <i className="bi bi-question-circle-fill"></i>
                                                        {showTooltip1 && (
                                                            <div className="cart-tax-tooltip" style={{
                                                                position: 'absolute', top: '-30px', left: '-210px', zIndex: '1', width: '200px', padding: '0.875rem',
                                                                backgroundColor: '#fbf3bf', border: '0.063rem solid #ccc', boxShadow: '0 0 0.625rem #ccc', lineHeight: '1.125rem',
                                                                letterSpacing: '0', color: '#333', borderRadius: '0.313rem', textAlign: 'left',
                                                                fontSize: '0.75rem', fontWeight: '400'
                                                            }}>
                                                                <div className="cart-tax-tooltip-arrow" style={{
                                                                    position: 'absolute', top: '30px', left: '108%', marginLeft: '-15px', width: '0', height: '0',
                                                                    borderTop: '5px solid transparent', borderBottom: '5px solid transparent', borderLeft: '7px solid #333',
                                                                }}></div>
                                                                Tax will be calculated according to your shipping zip code.
                                                            </div>
                                                        )}
                                                    </span>
                                                    <span>Tax:</span>
                                                </span>
                                            </div>
                                            <div className="col-5 cart-charge-value">
                                                <span className={`${estimateShippingRef.current && !estimateShippingRef.current.tax
                                                    && (estimateShippingRef.current && estimateShippingRef.current.noPreviousZipCodeMsgForTax
                                                        || userTypeRef.current && userTypeRef.current.transient) ? "anonymous" : "$0.00"}`}>
                                                    {estimateShippingRef.current && estimateShippingRef.current.tax ? estimateShippingRef.current.tax :
                                                        estimateShippingRef.current && estimateShippingRef.current.noPreviousZipCodeMsgForTax ? estimateShippingRef.current.noPreviousZipCodeMsgForTax :
                                                            userTypeRef.current && userTypeRef.current.transient === true ?
                                                            "Calculated at checkout" : "$0.00"
                                                    }</span>
                                            </div>
                                        </div> : ""}
                                    <div id="subtotal" className="row totals-line total">
                                        <div className="col-7 cart-charge">
                                            <span>{userTypeRef.current == 3 ? "Merchandise Total" : "Subtotal"}:</span>
                                        </div>
                                        {profileDetail && profileDetail.hidePrice && profileDetail.hidePrice === "false" ?
                                            <div className="col-5 cart-charge-value">{estimateShippingRef.current && estimateShippingRef.current.finalTotal ?
                                                estimateShippingRef.current.finalTotal : subTotal ? subTotal : emptyCart ? "$0.00" : ""}
                                            </div> : ""}
                                    </div>
                                </div>

                                {isPunchoutInspect ?
                                    <div className="totals-checkout text-center text-md-end">
                                        <a className={`btn ${!emptyCart ? "btn-primary" : "btn-disable"}`} href="https://staging.suppliersolutions.com/carolina/suppliers/carolina/receivecart.asp">EXIT CART</a>
                                    </div>
                                    :
                                    profileDetail && profileDetail.userTypeCheck && Object.keys(profileDetail.userTypeCheck).length > 0 &&
                                        profileDetail.userTypeCheck.user != "csr" && profileDetail.userTypeCheck.user != "imperson" && profileDetail.userTypeCheck.punchoutClient ?
                                        <div className="totals-checkout text-center text-md-end">
                                            <button className={`btn ${!emptyCart ? "btn-primary" : "btn-disable"}`} onClick={handlePunchOutCheckOut}>SEND CART TO {profileDetail.userTypeCheck && profileDetail.userTypeCheck.punchoutClient}</button>
                                        </div> :
                                        <div className="totals-checkout text-center text-md-end">
                                            <button className={`btn ${!emptyCart ? "btn-primary" : "btn-disable"}`} onClick={handleCheckOut}>{userTypeRef.current === 3 ? "Submit Quote Request" : "Checkout"}</button>
                                        </div>
                                }
                            </div>
                        </div>
                    </div >
                </div >

                {
                    !isPunchoutInspect && userTypeRef.current && userTypeRef.current === 2 || userTypeRef.current === 1 || cartBelowAreaRef.current ?
                        <div class="row mt-4">
                            <div class="col col-12">
                                <div class="cart-targeter" dangerouslySetInnerHTML={{ __html: cartBelowAreaRef.current }}></div>
                            </div>
                        </div> : ""
                }

            </div >
            {/* You may also Like */}
            {siteSpecDetailsRef.current && !isPunchoutInspect ? <YouMayAlso siteSpec={siteSpecDetailsRef.current} quickviewCallback={handleQuickView} /> : ""}
            {productDetailsObjRef.current ? <ProductQuickViewModal productObj={productDetailsObjRef.current} cartDetailsCallBack={cartDetailsCallBack} /> : ""}
            <p id="mergeModal"></p>
            {/* Merge Cart Modal*/}
            < div className="modal fade" id="mergeCartModal" tabindex="-1" aria-labelledby="mergeCartModalLabel" aria-hidden="true" >
                <div class="modal-dialog modal-dialog-centered modal-fullscreen-sm-down modal-lg-a">
                    <div class="modal-content">
                        <button type="button" id="merge-cart-close" className="btn-close" onClick={handleClose} data-bs-dismiss="modal" aria-label="Close"></button>
                        <div class="modal-body">
                            <div class="container-fluid merge-cart-modal-body">
                                <div class="row my-4">
                                    <div class="col-12">
                                        <h3 class="modal-title" id="mergeCartModalLabel">
                                            Merged Cart Notice
                                        </h3>
                                        <p>
                                            We have identified a previous cart you created. Please choose how you want to proceed with your cart. Be sure to check your shopping cart after continuing to review your items.
                                        </p>
                                    </div>
                                </div>
                                <div class="row justify-content-md-between">
                                    <div class="col-12 col-md-3 mb-5">
                                        <h4 class="modal-sub-heading">
                                            Current Cart
                                        </h4>
                                        <p class="merge-cart mb-4">
                                            Keep current shopping cart that has {commerceItemDetails && commerceItemDetails.currentCommereceItemCount} items and totals {commerceItemDetails && commerceItemDetails.currentCommerceItemTotal}
                                        </p>
                                        <Link onClick={() => handleMergeCart("currentCart")} class="btn-primary merge-model modal-continue" id="currentCart" style={{ cursor: 'pointer' }}>
                                            Use Current Cart
                                        </Link>
                                    </div>
                                    <div class="col-12 col-md-3 mb-5">
                                        <h4 class="modal-sub-heading">
                                            Previous Cart
                                        </h4>
                                        <p class="merge-cart mb-4">
                                            Used last logged in shopping cart that has {commerceItemDetails && commerceItemDetails.previousCommereceItemquantity} items and totals {commerceItemDetails && commerceItemDetails.previousCommerceItemTotal}
                                        </p>
                                        <Link onClick={() => handleMergeCart("previousCart")} class="btn-primary merge-model modal-continue" id="previousCart" style={{ cursor: 'pointer' }}>
                                            Use Previous Cart
                                        </Link>
                                    </div>
                                    <div class="col-12 col-md-3 mb-5">
                                        <h4 class="modal-sub-heading">
                                            Merge Carts
                                        </h4>
                                        <p class="merge-cart mb-4">
                                            Merge both shopping carts together, keeping all items. If using a promotion code, the most recent code applied, will be kept. You can change the promotion code in your cart.
                                        </p>
                                        <Link onClick={() => handleMergeCart("mergeCart")} class="btn-primary merge-model modal-continue" id="mergeCart" style={{ cursor: 'pointer' }}>
                                            Merge Both Carts
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <form method="post" action="/spc/cart.jsp?_DARGS=/spc/includes/mergeCartIntermediateRequest.jsp" id="cartOptions-form">
                                {/* <div style="display:none">
                                <input name="_dyncharset" type="hidden" value="UTF-8" />
                            </div> */}
                                {/* <div style="display:none">
                                <input name="_dynSessConf" type="hidden" value="-7246913166763709267" />
                            </div> */}
                                <input name="cartType" id="cartType" type="hidden" value="" />
                                <input name="_D:cartType" type="hidden" value=" " />
                                <input name="/atg/commerce/order/purchase/CartModifierFormHandler.selectCart" type="hidden" value="submit" />
                                <input name="_D:/atg/commerce/order/purchase/CartModifierFormHandler.selectCart" type="hidden" value=" " />
                                {/* <div style="display:none">
                                <input name="_DARGS" type="hidden" value="/spc/includes/mergeCartIntermediateRequest.jsp" />
                            </div> */}
                            </form>
                        </div>
                    </div>
                </div>
            </div >
            {/* Warning Modal*/}
            <div class="modal fade c-modal show" id="prop65-modal-228424" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="prop65-modal-228424" aria-modal="true" role="dialog">
                <div class="modal-dialog modal-dialog-centered modal-fullscreen-sm-down">
                    <div class="modal-content">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        <div class="modal-body">
                            <div class="prop65Div">
                                <p>
                                    <b>California Proposition 65: </b>
                                </p>
                                <div class="d-flex mb-4">
                                    <img src="/images/prop65icon_lg.png" class="prop65-restrictions-icon" />
                                    <div class="desc_prop65"><b>WARNING:</b> Cancer –  <a href="https://www.P65Warnings.ca.gov" target="_blank">www.P65Warnings.ca.gov </a></div>
                                </div>
                                <div>
                                    <button type="button" class="btn btn-primary" data-bs-dismiss="modal">CLOSE WINDOW</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* {isPunchoutRef.current ? */}
            <form className='d-none' action={externalRedirectionURLRef.current} method="post">
                <input type="hidden" name="sessionId" value={sessionIdRef.current} />
                <input type="hidden" name="action" value="create" />
                {
                    cartProductListRef.current && cartProductListRef.current.length > 0 ? cartProductListRef.current.map((value, index) => {
                        return (
                            <>
                                <input type="hidden" name="sku" value={value.sku ? value.sku : ""} />
                                <input type="hidden" name="unitOfMeasure" value={value.unitOfMeasure ? value.unitOfMeasure : ""} />
                                <input type="hidden" name="line" value={value.line ? value.line : ""} />
                                <input type="hidden" name="quantity" value={value.quantity ? value.quantity : ""} />
                                <input type="hidden" name="price" value={value.price ? value.price : ""} />
                                <input type="hidden" name="description" value={value.description ? value.description : ""} />
                                <input type="hidden" name="UNSPSC" value={value.UNSPSC ? value.UNSPSC : ""} />
                                <input type="hidden" name="manufacturerName" value={value.manufacturerName ? value.manufacturerName : ""} />
                            </>
                        )
                    }) : ""
                }
                <input type="submit" className="d-none" id="punchoutPortalFormSubmit" />
            </form>

            {/* modal */}
            <ProductRestrictModalCart
                restrictedTitle={restrictedTitle}
                restrictedDiscontinueItem={restrictedDiscontinueItem}
                restrictedItemGeo={restrictedItemGeo}
                restrictedItem={restrictedItem}
                restrictedItemSpecialUser={restrictedItemSpecialUser}
                handleGetCartList={handleGetCartList}
                handleCheckOut={handleCheckOut}
                hasScrollView={hasScrollView}
                setHasScrollView={setHasScrollView}
                setCheckoutQuarantine={setCheckoutQuarantine}
                cartCount={profileDetail?.miniCartCount}
                setIsRestrictedModalShow={setIsRestrictedModalShow}
                hideModal={hideModalRef.current}
                guestUser={profileDetail?.transient}
            />
        </>

    )
}

export default ShoppingCartV2
